//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'
import * as moment from 'moment'

//#endregion

//#region DevExpress Imports

import DevExpress from 'devextreme'

//#endregion

// #region Imports

import { Dictionary, KeyType } from '../../../helpers/'
import { CommonHelper, DeviceFunctionType } from '../../../helpers/common-helper'
import { ConfigHelper } from '../../../helpers/config-helper'
import { ConvertHelper } from '../../../helpers/convert-helper'
import { EventsNames } from '../../../helpers/events-names'
import { LocalizationHelper } from '../../../helpers/localization-helper'
import { LogHelper } from '../../../helpers/log-helper'
import { MapHelper } from '../../../helpers/map-helper'
import { OperatorLayoutSettings } from '../../../helpers/operator-layout-settings'
import { TemplateHelper } from '../../../helpers/template-helper'
import { ToastHelper } from '../../../helpers/toast-helper'
import { TypeHelper } from '../../../helpers/type-helper'
import { Activity } from '../../../models/common/activity'
import { Enums } from '../../../models/common/enums'
import {
	OpAlarmDef,
	OpConfigurationProfile,
	OpData,
	OpDevice,
	OpDeviceType,
	OpLocation,
	OpMeter,
	OpMeterType,
	OpScheduleConfiguration,
	OpConfigurationProfileFunction,
	OpTariff,
	OpIssue,
} from '../../../models/core'
import { OpDataTypeInGroup } from '../../../models/core/op-data-type-in-group'
import { OpView } from '../../../models/core/op-view'
import { OpViewColumn } from '../../../models/core/op-view-column'
import { ColumnInfo, OpActionResult, OpLocationConfigurationProfile, OpSchema } from '../../../models/custom'
import { OpMarker } from '../../../models/custom/op-map-area'
import { OpValidateInfo } from '../../../models/custom/op-validate-info'
import { IAlarmConfigurable, IReferenceType, IOpData } from '../../../models/util/interfaces'
import { DeviceService } from '../../../services/device'
import { GridService } from '../../../services/grid'
import { LocationService } from '../../../services/location'
import { DataTypeGroupService } from '../../../services/data-type'
import { SystemService } from '../../../services/system/system.service'
import { UserSessionService } from '../../../services/user-session'
import { ColumnModel, ConfigurationProfileFunctionModel, MeasurementModel, ScheduleConfigurationModel, SchemaModel } from '../../api/api.models'
import { LocalDictionaryFactory } from '../../api/api.module'
import { Source } from '../../common/action-run/action-run.controller'
import { ActionStatusOptions } from '../../common/action-status/action-status.controller'
import { AlarmDefinitionsOptions, IAlarmDefinitions } from '../../common/alarm-definition/alarm-definitions'
import { IAlarmDefinitionsEditOptions } from '../../common/alarm-definition/alarm-definitions-edit'
import { Details, DetailsAccordion, DetailsAccordionSection, DetailsScope } from '../../common/common.details'
import { GridBridge } from '../../common/common.interfaces'
import { LoggerService } from '../../common/common.module'
import { DetailsParametersOptions } from '../../common/details-parameters/details-parameters.directive'
import { DetailsOptions, DetailsPopupOptions } from '../../common/details-popup/details-popup.directive'
import { GridEditController } from '../../common/grid-edit/grid-edit.controller'
import { GridController, GridOptions, GridTypes } from '../../common/grid/grid.controller'
import { HistorySource } from '../../common/history/history.directive.controller'
import { ItemSwapperPopupOptions, IItemSwapperPopup, ItemSwapperResult } from '../../../modules/common/item-swapper/'
import { Map, MapLegendItem, MapOptions } from '../../common/map2/map.directive.controller'
import { MeasurementsChartBridge } from '../../common/measurements/chart/chart.directive.controller'
import { MeasurementsBridge } from '../../common/measurements/measurements.controller'
import { SourcePopover } from '../../common/select-box-popup/select-box-popup.directive'
import { TreeListOptions } from '../../common/tree-list/tree-list.controller'
import { LocationEquipmentService } from '../../../services/location/location.equipment.service'
import { ExtendedParametersService } from '../../../services/extended-parameters'
import { AlarmDefinitionsEditController } from '../../common/alarm-definition/alarm-definitions-edit/alarm-definitions-edit.directive.controller'
import { MeterService } from '../../../services/meter'
import { ReferenceTypeService } from '../../../services/reference-type'
import { DataProviderListResult } from '../../../data-provider'
import { CreateEditResult } from '../../../services/system'
import { IIMRLocationSchemaAssignPopup, IIMRLocationSchemaAssignPopupInitializedArgs, IMRILocationSchemaAssignPopupOptions } from '../location-schema-assign-popup/location-schema-assign-popup.interfaces'

// #endregion

// #region MxGrapOptions

type MxGrapOptions = {
	location: OpLocation
	schema: any
	schemaModel: any
	frameId: any
	visualizationOnly: boolean
	control: any
	language: string
	scripts: any
	datatypeDict: Dictionary<IReferenceType>
}

// #endregion

// #region ConfigurationProfileEntry

type ConfigurationProfileEntry = {
	caption: string
	name: string
	value: any
	type: string
	id?: number | string
	tooltip?: {
		icon: string
		tooltipText: string
	}
	styleForValue?: any
}

// #endregion

// #region ConfigurationProfileSelectBoxItem

type ConfigurationProfileSelectBoxItem = {
	id: number
	name: string
	descr: string
}

// #endregion

// #region MeasurementBridgeOpObjects

type MeasurementBridgeOpObjects = {
	id: number
	name: string
	referenceId: number
}

// #endregion

// #region ILocationDetailsScope

interface ILocationDetailsScope extends DetailsScope {
	// #region Localization

	ConfigurationText: string
	NoSchemaText: string

	// #endregion

	// #region Template consts

	LOCATION_COMMON_TAB_NAME: string
	LOCATION_MEASUREMENTS_TAB_NAME: string
	LOCATION_HISTORY_TAB_NAME: string
	LOCATION_SCHEMA_TAB_NAME: string

	LOCATION_PARAMS_ACCORDION_NAME: string
	LOCATION_EXTENDED_PARAMS_ACCORDION_NAME: string
	LOCATION_MEASUREMENT_CHART_ACCORDION_NAME: string
	LOCATION_GROUPS_ACCORDION_NAME: string
	LOCATION_INSTALLED_DEVICES_ACCORDION_NAME: string
	LOCATION_INSTALLED_METERS_ACCORDION_NAME: string
	LOCATION_MEASUREMENT_TABLE_ACCORDION_NAME: string
	LOCATION_ISSUES_TABLE_ACCORDION_NAME: string
	LOCATION_MAP_ACCORDION_NAME: string
	LOCATION_CONFIGURATION_PROFILE_ACCORDION_NAME: string
	LOCATION_TARIFF_ACCORDION_NAME: string
	LOCATION_ALARM_DEFS_ACCORDION_NAME: string

	DELETE_CONFIRMATION_POPUP_ID: string

	ACTION_RUN_POPUP_ID: string
	ACTION_STATUS_POPUP_ID: string

	SEND_LOCATION_CONFIGURATION_ID: string
	VALIDATION_WARNING_ID: string

	// #endregion

	// #region Popup

	id: number
	editId: number
	popupFor: any
	popupTitle: string

	// #endregion

	// #region Schema Options

	graphOptions: MxGrapOptions
	graphOptionsCommon: MxGrapOptions

	saveSchemaButtonOptions: DevExpress.ui.dxButtonOptions
	createSchemaButtonOptions: DevExpress.ui.dxButtonOptions

	// #endregion

	// #region Location options

	detailsParametersOptions: DetailsParametersOptions
	extendedParamsGridOptions: TreeListOptions

	historySource: HistorySource

	installedDevicesGridOptions: GridOptions
	installedMetersGridOptions: GridOptions
	locationGroupsGridOptions: GridOptions

	mapOptions: MapOptions

	devicesBridge: GridBridge
	metersBridge: GridBridge
	locationGroupsItemSwapperPopupOptions: ItemSwapperPopupOptions<OpLocation>

	// #endregion

	// #region Measurement options

	measurementsBridge: MeasurementsBridge
	measurementsChartBridge: MeasurementsChartBridge

	// #endregion

	// #region Profile options

	profileSource: Source
	sendLocationConfigurationProfileButtonOptions: DevExpress.ui.dxButtonOptions

	// #endregion

	// #region Tariff options

	locationTariffOptions: ConfigurationProfileEntry[]

	// #endregion

	// #region Alarms options

	alarmDefinitionsOptions: AlarmDefinitionsOptions
	alarmDefinitionsEditOptions: {
		alarmDefinitionsOptions: IAlarmDefinitionsEditOptions
		onInitialized: (component: AlarmDefinitionsEditController) => void
	}

	// #endregion

	// #region Confirmations

	meterDeviceRelocationConfirmationSource: {
		title: string
		onConfirmed: () => void
		onDeclined: () => void
	}

	locationValidationConfirmationSource: {
		title: string
		onConfirmed: () => void
		onDeclined: () => void
	}

	sendLocationConfigurationProfileConfirmationSource: {
		title: string
		onConfirmed: () => void
	}

	deleteConfirmationOptions: {
		title: string
		onConfirmed: () => void
	}

	// #endregion

	// #region Schema

	isSchemasLoading: boolean
	schemas: SchemaModel[]

	isSchemasVisible: () => boolean
	isMxGraphVisible: () => boolean

	locationSchemaAssignButtonOptions: DevExpress.ui.dxButtonOptions
	locationSchemaAssignPopupOptions: IMRILocationSchemaAssignPopupOptions

	// #endregion

	// #region Profiles

	deviceFunctionTypes: { name: string; id: number }[]
	configurationProfiles: OpConfigurationProfile[]
	assignedConfigurationProfile: OpLocationConfigurationProfile
	profileFunctionsList: ConfigurationProfileFunctionModel[]
	configurationProfileDescription: string
	isConfigurationProfileDescrtiptionVisible: boolean
	isConfigurationProfileLoaderVisible: boolean
	isEditingConfigurationProfile: boolean
	locationProfileOptions: any[]
	locationTariffEditOptions: SourcePopover

	profileSelectBoxExists: () => boolean
	getProfileFunctionNameText: (typeName: string) => string
	locationTariffSelectBoxExists: () => boolean

	// #endregion

	// #region Measurements

	measurementsShow: () => void
	measurementsChartShow: () => void
	isGeneralMeasurementsMockRequired: boolean

	// #endregion

	//#region Issues

	showLocationIssues: boolean
	locationIssuesGridOptions: GridOptions

	//#endregion

	// #region Other

	isLocationStateTypeDeleted: boolean

	canEditSection: (section: any) => boolean

	// #endregion
}

// #endregion

export class LocationsDetailsDirectiveController extends Details<ILocationDetailsScope> {
	// #region Consts

	private static get LocationHistorySourceName(): string {
		return 'locationsHistory'
	}
	private static get LocationDevicesBridgeName(): string {
		return 'locationsDevicesGrid'
	}
	private static get LocationMetersBridgeName(): string {
		return 'locationsMetersGrid'
	}

	private static get LocationGroupsGridName(): string {
		return 'LocationDetailsGroups'
	}
	private static get LocationMetersGridName(): string {
		return 'LocationDetailsMeters'
	}
	private static get LocationDevicesGridName(): string {
		return 'LocationDetailsDevices'
	}
	private static get LocationIssuesGridName(): string {
		return 'LocationDetailsIssues'
	}

	private static get LocationDevicesPopupName(): string {
		return 'locationDevices'
	}
	private static get LocationMetersPopupName(): string {
		return 'locationMeters'
	}

	private static get DefaultAccordionName(): string {
		return 'common'
	}

	private get LocationDevicesBridgePopupIdName(): string {
		return this.$scope.detailsPopupId + 'devices'
	}
	private get LocationMetersBridgePopupIdName(): string {
		return this.$scope.detailsPopupId + 'meters'
	}

	// #endregion

	// #region Members

	private referenceObject: OpLocation
	private referenceObjectId: number

	private locationView: OpView
	private deviceView: OpView

	private deviceTypesDict: Dictionary<OpDeviceType>

	private measurementsData: MeasurementModel[]
	private isMeasurmentVisible: boolean

	private validationDeferred: JQueryDeferred<boolean>

	private alarmDefinitionsComponent: IAlarmDefinitions
	private alarmDefinitionsEditController: AlarmDefinitionsEditController

	private locationGroupsItemSwapperPopup: IItemSwapperPopup<OpLocation>

	private locationGroupsGrid: GridController<OpLocation>

	private map: Map

	private devicesGridEditController: GridEditController
	private deviceGridController: GridController<OpDevice>

	private metersGridEditController: GridEditController
	private meterGridController: GridController<OpMeter>

	private extendedParametersDxTreeList: DevExpress.ui.dxTreeList

	private locationIssues: OpIssue[]

	private locationSchemaAssignPopup: IIMRLocationSchemaAssignPopup

	// #endregion

	// #region Ctor

	constructor(
		$scope: ILocationDetailsScope,
		$timeout: ng.ITimeoutService,
		$q: ng.IQService,
		logger: LoggerService,
		localDictionary: LocalDictionaryFactory,
		private $sce: ng.ISCEService,
		protected referenceType: Enums.ReferenceType,
		protected moduleName: Enums.SimaxModuleName,
		protected userSession: UserSessionService,
		private systemService: SystemService,
		private locationService: LocationService,
		private locationEquipmentService: LocationEquipmentService,
		private deviceService: DeviceService,
		private meterService: MeterService,
		private gridService: GridService,
		private dataTypeGroupService: DataTypeGroupService,
		private extendedParametersService: ExtendedParametersService,
		private referenceTypeService: ReferenceTypeService
	) {
		super($scope, $timeout, $q, logger, localDictionary, OperatorLayoutSettings.LocationPopupTabActive, userSession, referenceType)

		this.$scope.editId = $scope.$id

		this.setDelegates()
		this.setLocalizationText()
		this.setConfirmationsOptions()
		this.setEvents()
		this.setOptions()
		this.setTemplateConsts()
		this.setLocationSchemaAssignPopupOptions()
		this.setLocationSchemaAssignButtonOptions()

		if (this.userSession.getLoggedOperator().hasPermission(Activity.LOCATION_LIST)) {
			this.configureTabs(this.getTabs())
		}
	}

	// #endregion

	// #region Events

	private onOpen(options: DetailsOptions): void {
		this.$scope.options.isDataLoaded = false

		this.$scope.detailsOpenParams = options
		this.$scope.popupFor = CommonHelper.location
		this.accordionsNameToShow = LocationsDetailsDirectiveController.DefaultAccordionName

		this.referenceObjectId = options.referenceObjectId

		this.$scope.isEditingConfigurationProfile = false
		this.$scope.isConfigurationProfileLoaderVisible = false

		this.onClear()
		this.onRefresh()
		this.setHistoryOptions()
		this.showPopup()
	}

	private onRefresh(toRefresh: OpLocation = null): void {
		this.$scope.options.isDataLoaded = false

		if (this.$scope.tabs.selectedTabName === this.$scope.LOCATION_MEASUREMENTS_TAB_NAME) {
			this.$scope.isLoading = true
		}

		const deferred: JQueryDeferred<OpLocation> = $.Deferred<OpLocation>()

		if (toRefresh == null) {
			this.userSession
				.getDataProvider()
				.Location.getLocation(this.referenceObjectId)
				.then((result: OpLocation) => {
					this.$scope.popupTitle = result.toString()
					deferred.resolve(result)
				})
				.fail((error: any) => {
					const errorMsg: string = ConvertHelper.getRequestErrorMessage(error) || LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ExceptionOccuredPleaseContactAnAdministrator)
					ToastHelper.showError(errorMsg)
					LogHelper.error(LocationService.LOG_PREFIX, errorMsg)

					deferred.resolve(null)
				})
				.always(() => {
					this.$scope.showTabs = true
				})
		} else {
			deferred.resolve(toRefresh)
		}

		deferred.promise()
			.then((result: OpLocation) => {
				if (result != null && (this.referenceObject == null || this.referenceObject.idLocation == result.idLocation)) {
					this.referenceObject = result

					return $.when(
						this.setLocationIssuesGridOptions(),

						this.setLocationStateTypeFlag(),

						this.setBasicParameters(),
						this.setExtendedParameters(),
						this.setSchemas(),
						this.setMeasurementOptions(),
						this.setInstalledDevicesGridOptions(),
						this.setInstalledMetersGridOptions(),
						this.setLocationGroupsGridOptions(),
						this.setConfigurationProfileOptions(),
						this.setSendLocationConfigurationProfileButtonOptions(),
						this.setMapOptions(),
						this.setAlarmDefinitionsOptions(),
						this.setLocationTariffOptions(),

						this.setLocationGroupsItemSwapperOptions(),
						this.setLocationInstalledDevicesBridgeOptions(),
						this.setLocationInstalledMetersBridgeOptions(),
						this.setLocationTariffEditOptions(),

						this.setMapMarker()
					)
				}
			})
			.always(() => {
				this.$scope.options.isDataLoaded = true
				this.$scope.isLoading = false
			})
	}

	private onClear(): void {
		this.$scope.popupTitle = TypeHelper.emptyString
		this.$scope.showTabs = false

		this.referenceObject = null
		this.$scope.detailsParametersOptions = null

		this.$scope.extendedParamsGridOptions = null
		this.$scope.historySource = null
		this.$scope.measurementsBridge = null
		this.measurementsData = null
		this.$scope.schemas = null

		this.$scope.installedDevicesGridOptions = null
		this.$scope.installedMetersGridOptions = null
		this.$scope.locationGroupsGridOptions = null
	}

	private onClose(): void {
		this.hidePopup()
	}

	private onConfirmDelete(): void {
		this.locationService
			.deleteLocation(this.referenceObjectId)
			.then(() => {
				this.$scope.$root.$broadcast(EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__DELETED, this.moduleName))
				this.onClose()
			})
			.fail((error: any) => {
				LogHelper.error(LocationService.LOG_PREFIX, error)
			})
	}

	private onDelete(): void {
		this.$scope.$broadcast(
			EventsNames.OPEN_CONFIRMATION_POPUP + this.$scope.DELETE_CONFIRMATION_POPUP_ID,
			LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__CONFIRM_DELETE, this.moduleName)
		)
	}

	private onExtendedParameterCellPrepared(options: any): void {
		this.extendedParametersService.onExtendedParameterCellPrepared(options)
	}

	private onLocationGroupsEdit(): void {
		if (this.locationGroupsItemSwapperPopup != null) {
			this.locationGroupsItemSwapperPopup.itemSwapper.setRightGridDataSource(() => {
				return this.getParentGroups()
			})
			this.locationGroupsItemSwapperPopup.itemSwapper.reset()
			this.locationGroupsItemSwapperPopup.show()
		} else {
			ToastHelper.showError(LocalizationHelper.Text.AttemptedToOpenLocationGroupsEditButPopupDoestNotExist)
			LogHelper.error(LocationService.LOG_PREFIX, 'Attempted to open location groups edit but popup does not exist.')
		}
	}

	private onLocationInstalledDevicesEdit(): void {
		this.$scope.$broadcast(EventsNames.OPEN_GRID_EDIT_POPUP + this.LocationDevicesBridgePopupIdName, LocationsDetailsDirectiveController.LocationDevicesPopupName, false)
	}

	private onLocationInstalledMetersEdit(): void {
		this.$scope.$broadcast(EventsNames.OPEN_GRID_EDIT_POPUP + this.LocationMetersBridgePopupIdName, LocationsDetailsDirectiveController.LocationMetersPopupName)
	}

	private onConfigureProfile(): void {
		if (this.$scope.isEditingConfigurationProfile == true && this.$scope.assignedConfigurationProfile.configurationProfile != null) {
			this.$scope.$root.$broadcast(
				EventsNames.OPEN_DEVICE_CONFIGURATION + this.$scope.modelId,
				this.$scope.assignedConfigurationProfile.configurationProfile.idConfigurationProfile,
				this.$scope.profileFunctionsList
			)
		}
	}

	private onConfigurationProfileEdit(): void {
		this.$scope.$root.$broadcast(EventsNames.OPEN_SELECT_BOX_POPUP + this.$scope.modelId, [])
	}

	private onInstalledDevicesDoubleClick(args: any): void {
		if (this.userSession.getLoggedOperator().hasPermission(Activity.DEVICE_LIST)) {
			this.systemService.openDetails(this.deviceService.getDetailsOptions(args.data[CommonHelper.idField]))
		}
	}

	private onInstalledMetersDoubleClick(args: any): void {
		if (this.userSession.getLoggedOperator().hasPermission(Activity.METER_LIST)) {
			this.systemService.openDetails(this.meterService.getDetailsOptions(args.data[CommonHelper.idField]))
		}
	}

	private onSendLocationConfigurationProfileClick(): void {
		if (this.$scope.assignedConfigurationProfile.configurationProfile != null) {
			if (_.size(this.referenceObject.currentDevices) > 0) {
				const text: string =
					LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ActionSendProfileText) + '<br>' + this.referenceObject.currentDevices.map((device: OpDevice) => device.serialNbr).join(',<br>')

				this.$scope.$broadcast(EventsNames.OPEN_CONFIRMATION_POPUP + this.$scope.SEND_LOCATION_CONFIGURATION_ID, text)
			} else {
				ToastHelper.showInfo(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoDevicesToSendProfileConfiguration))
			}
		} else {
			ToastHelper.showInfo(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoConfigurationProfileSelected))
		}
	}

	private onMapInit(map: Map): void {
		this.map = map
		this.setMapMarker()
	}

	private onLocationGroupsDoubleClick(args: any): void {
		this.systemService.openDetails(this.locationService.getDetailsOptions(args.data[CommonHelper.idField]))
	}

	private onLocationIssuessDoubleClick(args: any, issues: OpIssue[]): void {
		this.systemService.openDetails(<
			DetailsOptions //TODO replace it to issueService when it created
			>{
				moduleName: Enums.SimaxModuleName.Issue,
				pageItemsIds: issues.map((issue: OpIssue) => issue.idIssue),
				referenceObjectId: args.data[CommonHelper.idField],
			})
	}

	private onUpdateConfigurationProfileFunctionList(args: any[]): void {
		if (_.size(args) > 0) {
			const newConfigurationFunction: OpScheduleConfiguration = TypeHelper.clone(args[0])

			if (this.$scope.assignedConfigurationProfile != null) {
				let alreadyExistsCount: number = 0

				const newConfigurationList: OpScheduleConfiguration[] = this.$scope.assignedConfigurationProfile.configurationProfile.functionList.map((item: OpScheduleConfiguration) => {
					if (item.indexNbr === newConfigurationFunction.indexNbr) {
						alreadyExistsCount++
						return newConfigurationFunction
					}

					return item
				})

				this.$scope.assignedConfigurationProfile.configurationProfile.functionList = newConfigurationList

				if (alreadyExistsCount === 0) {
					this.$scope.assignedConfigurationProfile.configurationProfile.functionList.push(newConfigurationFunction)
				}

				this.updateProfileParameters(this.$scope.assignedConfigurationProfile)
			}
		}
	}

	private onSaveSchemaClick(): void {
		const schemaXML: any = this.$scope.graphOptions == null || this.$scope.graphOptions.control == null ? null : this.$scope.graphOptions.control(this.$scope.graphOptions)

		const schemaToSave: OpSchema = new OpSchema(null)

		if (schemaXML != null) {
			schemaToSave.schema = ConvertHelper.unicodeStringToByteArray(schemaXML)
		}

		schemaToSave.idObject = this.$scope.graphOptions.schemaModel.idObject
		schemaToSave.referenceType = this.$scope.graphOptions.schemaModel.referenceType
		schemaToSave.width = this.$scope.graphOptions.schemaModel.width
		schemaToSave.height = this.$scope.graphOptions.schemaModel.height
		schemaToSave.class = Enums.LocationSchemaClass.MXGraph
		schemaToSave.indexNbr = this.$scope.graphOptions.schemaModel.indexNbr

		this.saveOpxSchema(schemaToSave)
	}

	private onCreateSchemaClick(): void {
		if (this.userSession.getLoggedOperator().hasPermission(Activity.SCHEMA_ADD)) {
			this.createEmptySchema().then(() => {
				this.setSchemas()
			})
		}
	}

	private onLocationGroupsSave(result: ItemSwapperResult<OpLocation>): JQueryPromise<OpLocation> {
		if (result != null) {
			const location: OpLocation = new OpLocation(null)
			location.idLocation = this.referenceObjectId
			location.opState = Enums.OpChangeState.Modified
			location.parentGroups = []

			location.parentGroups = (result.addedToRight || []).map((parent: OpLocation) => {
				parent.opState = Enums.OpChangeState.New
				return parent
			})

			if (_.size(this.referenceObject.parentGroups) > 0) {
				; (result.addedToLeft || []).forEach((removed: OpLocation) => {
					removed.opState = Enums.OpChangeState.Delete
					location.parentGroups.push(removed)
				})

				this.referenceObject.parentGroups.forEach((existing: OpLocation) => {
					if (!location.parentGroups.some((toSave: OpLocation) => toSave.idLocation == existing.idLocation)) {
						existing.opState = Enums.OpChangeState.Loaded
						location.parentGroups.push(existing)
					}
				})
			}

			return this.trySaveLocation(location).then((saved: OpLocation) => {
				this.referenceObject.parentGroups = saved.parentGroups

				this.setLocationGroupsGridOptions()

				if (this.locationGroupsGrid != null) {
					this.locationGroupsGrid.setDataSource(this.referenceObject.parentGroups)
				}

				this.$scope.$root.$broadcast(EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__REFRESH, this.moduleName)) //need to refresh main grid source

				return saved
			})
		}

		return null
	}

	private onLocationGroupsItemSwapperInitialized(itemSwapper: IItemSwapperPopup<OpLocation>): void {
		this.locationGroupsItemSwapperPopup = itemSwapper
	}

	private onLocationGroupsLocationDoubleClick(args: any): void {
		this.systemService.openDetails(this.locationService.getDetailsOptions(args.data[CommonHelper.idField]))
	}

	private onSelectConfigurationProfileClick(idConfigurationProfile: number, profile: OpLocationConfigurationProfile): void {
		if (profile != null) {
			const profileFilter: OpConfigurationProfile = _.first(this.$scope.configurationProfiles.filter((profile: OpConfigurationProfile) => profile.idConfigurationProfile == idConfigurationProfile))
			profile.configurationProfile = profileFilter
			this.saveProfile(profile)
		} else {
			ToastHelper.showError(LocalizationHelper.Text.AttemptedToSetConfigurationProfileOnProfileButProfileDoesNotExist)
			LogHelper.error(LocationService.LOG_PREFIX, 'Attempted to set configuration profile on `profile` but the `profile` is null.')
		}
	}

	private onLocationGroupsGridInitialized(args: any, grid: GridController<OpLocation>): void {
		this.locationGroupsGrid = grid
	}

	private onDevicesBridgeControllerInitialized(controller: any): void {
		this.devicesGridEditController = controller as GridEditController
	}

	private onDevicesBridgeApply(added: any[], removed: any[], inGrid: any[]): JQueryPromise<boolean> {
		this.devicesGridEditController.setIsLoading(true)

		return this.saveInstalledDevices(added, removed, inGrid)
	}

	private onMetersBridgeControllerInitialized(controller: any): void {
		this.metersGridEditController = controller as GridEditController
	}

	private onMetersBridgeApply(added: any[], removed: any[], inGrid: any[]): JQueryPromise<boolean> {
		this.metersGridEditController.setIsLoading(true)

		return this.saveInstalledMeters(added, removed, inGrid)
	}

	private onDeviceGridInitialized(args: any, controller: GridController<OpDevice>): void {
		this.deviceGridController = controller
	}

	private onMeterGridInitialized(args: any, controller: GridController<OpMeter>): void {
		this.meterGridController = controller
	}

	private onExtendedParametersInitialized(args: any): void {
		this.extendedParametersDxTreeList = args.component
	}

	// #endregion

	//#region Actions

	private getActions(): DevExpress.ui.dxButtonOptions[] {
		const actions: DevExpress.ui.dxButtonOptions[] = []

		if (this.userSession.getLoggedOperator().hasPermission(Activity.LOCATION_COPY)) {
			actions.push({
				hint: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Copy),
				template: TemplateHelper.getIconWithText(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Copy), ConfigHelper.Icon.CONTENT_COPY, this.userSession),
				width: '100%',

				onClick: (e: any) => {
					this.$scope.$root.$broadcast(EventsNames.INITIALIZE_CREATE_EDIT_POPUP, this.locationService.getCreateEditOptions(this.referenceObjectId, this.referenceObject, undefined, true))
				},
			})
		}

		return actions
	}

	//#endregion

	// #region Setup

	public getAccordions(): DetailsAccordion[] {
		const accordions: DetailsAccordion[] = []

		const hasParametersPermission: boolean = !this.userSession.getLoggedOperator().hasPermission(Activity.LOCATION_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.LocationParameters)
		const hasGeneralSchemaPermission: boolean = !this.userSession
			.getLoggedOperator()
			.hasPermission(Activity.LOCATION_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.LocationGeneralSchema)
		const hasGeneralMeasurementPermission: boolean = !this.userSession
			.getLoggedOperator()
			.hasPermission(Activity.LOCATION_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.LocationMeasurement)
		const hasGroupsPermission: boolean = !this.userSession.getLoggedOperator().hasPermission(Activity.LOCATION_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.LocationGroups)

		const hasInstalledDevicesPermission: boolean = !this.userSession
			.getLoggedOperator()
			.hasPermission(Activity.LOCATION_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.LocationInstalledDevices)
		const hasInstalledMetersPermission: boolean = !this.userSession
			.getLoggedOperator()
			.hasPermission(Activity.LOCATION_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.LocationInstalledMeters)

		const hasMapPermission: boolean = !this.userSession.getLoggedOperator().hasPermission(Activity.LOCATION_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.LocationMap)
		const hasExtendedParametersPermission: boolean = !this.userSession
			.getLoggedOperator()
			.hasPermission(Activity.LOCATION_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.LocationExtendedParameters)
		const hasConfigurationProfilePermission: boolean = !this.userSession
			.getLoggedOperator()
			.hasPermission(Activity.LOCATION_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.LocationConfigurationProfile)
		const hasTariffViewPermission: boolean = !this.userSession.getLoggedOperator().hasPermission(Activity.LOCATION_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.LocationTariff)
		const hasAlarmDefViewPermission: boolean = !this.userSession.getLoggedOperator().hasPermission(Activity.LOCATION_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.LocationAlarmDef)

		const hasIssuesViewPermission: boolean = !this.userSession.getLoggedOperator().hasPermission(Activity.LOCATION_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.LocationIssues, true)

		if (hasParametersPermission || hasGeneralSchemaPermission || hasGeneralMeasurementPermission) {
			const sections: DetailsAccordionSection[] = []

			if (hasParametersPermission || hasGeneralSchemaPermission) {
				sections.push({
					canEdit:
						this.userSession.getLoggedOperator().hasPermission(Activity.LOCATION_EDIT) &&
						!this.userSession.getLoggedOperator().hasPermission(Activity.LOCATION_DETAILS_READONLY_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.LocationParameters),

					name: this.$scope.LOCATION_PARAMS_ACCORDION_NAME,
					showInTab: this.$scope.LOCATION_COMMON_TAB_NAME,
					title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Parameters),

					showStatus: false,
					visible: true,

					editMethod: () => {
						this.locationService.openEditByLocation(this.referenceObject)
					},
				})
			}

			if (hasGeneralMeasurementPermission) {
				sections.push({
					canEdit: false,

					name: this.$scope.LOCATION_MEASUREMENT_CHART_ACCORDION_NAME,
					showInTab: this.$scope.LOCATION_COMMON_TAB_NAME,
					title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Measurements),

					showStatus: false,
					visible: true,
				})
			}

			const accordion: DetailsAccordion = new DetailsAccordion(this.$scope, this.$timeout, OperatorLayoutSettings.LocationAccordionsSettings, 0, sections, true)

			accordion.needRefresh = () => {
				this.refreshDetails()
			}

			accordions.push(accordion)
		}

		if (hasGroupsPermission || hasInstalledDevicesPermission || hasInstalledMetersPermission || hasGeneralMeasurementPermission || hasIssuesViewPermission) {
			const sections: DetailsAccordionSection[] = []

			if (hasGroupsPermission) {
				sections.push({
					canEdit:
						this.userSession.getLoggedOperator().hasPermission(Activity.LOCATION_EDIT) &&
						!this.userSession.getLoggedOperator().hasPermission(Activity.LOCATION_DETAILS_READONLY_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.LocationGroups),

					name: this.$scope.LOCATION_GROUPS_ACCORDION_NAME,
					showInTab: this.$scope.LOCATION_COMMON_TAB_NAME,
					title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Groups),

					showStatus: true,
					visible: true,

					editMethod: () => {
						this.onLocationGroupsEdit()
					},
					status: () => {
						return this.locationGroupsStatus()
					},
				})
			}

			if (hasInstalledDevicesPermission) {
				sections.push({
					canEdit:
						this.userSession.getLoggedOperator().hasPermission(Activity.LOCATION_EDIT) &&
						!this.userSession.getLoggedOperator().hasPermission(Activity.LOCATION_DETAILS_READONLY_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.LocationInstalledDevices),

					name: this.$scope.LOCATION_INSTALLED_DEVICES_ACCORDION_NAME,
					showInTab: this.$scope.LOCATION_COMMON_TAB_NAME,
					title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Devices),

					showStatus: true,
					visible: true,

					editMethod: () => {
						this.onLocationInstalledDevicesEdit()
					},
					status: () => {
						return this.locationInstalledDevicesStatus()
					},
				})
			}

			if (hasInstalledMetersPermission) {
				sections.push({
					canEdit:
						this.userSession.getLoggedOperator().hasPermission(Activity.LOCATION_EDIT) &&
						!this.userSession.getLoggedOperator().hasPermission(Activity.LOCATION_DETAILS_READONLY_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.LocationInstalledMeters),

					name: this.$scope.LOCATION_INSTALLED_METERS_ACCORDION_NAME,
					showInTab: this.$scope.LOCATION_COMMON_TAB_NAME,
					title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Meters),

					showStatus: true,
					visible: true,

					editMethod: () => {
						this.onLocationInstalledMetersEdit()
					},
					status: () => {
						return this.locationInstalledMetersStatus()
					},
				})
			}

			if (hasGeneralMeasurementPermission) {
				sections.push({
					canEdit: false,

					name: this.$scope.LOCATION_MEASUREMENT_TABLE_ACCORDION_NAME,
					showInTab: this.$scope.LOCATION_COMMON_TAB_NAME,
					title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.MeasurmentsDetails),

					showStatus: false,
					visible: true,
				})
			}

			if (hasIssuesViewPermission) {
				sections.push({
					canEdit: false,

					name: this.$scope.LOCATION_ISSUES_TABLE_ACCORDION_NAME,
					showInTab: this.$scope.LOCATION_COMMON_TAB_NAME,
					title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Issues),

					showStatus: true,
					visible: true,

					status: () => `${LocalizationHelper.getLocalizedText(LocalizationHelper.Text.IssuesCount)} ${_.size(this.locationIssues)}`,
				})
			}

			const accordion: DetailsAccordion = new DetailsAccordion(this.$scope, this.$timeout, OperatorLayoutSettings.LocationAccordionsSettings, 1, sections)

			accordion.needRefresh = () => {
				this.refreshDetails()
			}

			accordions.push(accordion)
		}

		if (hasMapPermission || hasExtendedParametersPermission || hasConfigurationProfilePermission || hasTariffViewPermission || hasAlarmDefViewPermission) {
			const sections: DetailsAccordionSection[] = []

			if (hasMapPermission) {
				sections.push({
					canEdit: false,

					name: this.$scope.LOCATION_MAP_ACCORDION_NAME,
					showInTab: this.$scope.LOCATION_COMMON_TAB_NAME,
					title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Map),

					showStatus: false,
					visible: true,
				})
			}

			if (hasExtendedParametersPermission) {
				sections.push({
					canEdit:
						this.userSession.getLoggedOperator().hasPermission(Activity.LOCATION_EDIT) &&
						!this.userSession.getLoggedOperator().hasPermission(Activity.LOCATION_DETAILS_READONLY_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.LocationExtendedParameters),

					name: this.$scope.LOCATION_EXTENDED_PARAMS_ACCORDION_NAME,
					showInTab: this.$scope.LOCATION_COMMON_TAB_NAME,
					title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.SpecificParameters),

					showStatus: false,
					visible: true,

					editMethod: () => {
						this.locationService.openExtendedParametersEditByLocation(this.referenceObject)
					},
				})
			}

			if (hasConfigurationProfilePermission) {
				sections.push({
					canEdit:
						this.userSession.getLoggedOperator().hasPermission(Activity.LOCATION_EDIT) &&
						!this.userSession.getLoggedOperator().hasPermission(Activity.LOCATION_DETAILS_READONLY_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.LocationConfigurationProfile),

					canConfigure: this.userSession.getLoggedOperator().hasPermission(Activity.SCHEDULE_LIST),
					canSendLocationConfigurationProfile: this.userSession.getLoggedOperator().hasPermission(Activity.LOCATION_CONFIGURATION_SEND),

					name: this.$scope.LOCATION_CONFIGURATION_PROFILE_ACCORDION_NAME,
					showInTab: this.$scope.LOCATION_COMMON_TAB_NAME,
					title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ProfileConfiguration),

					showStatus: false,
					visible: true,

					editMethod: () => {
						this.onConfigurationProfileEdit()
					},
					configureMethod: () => {
						this.onConfigureProfile()
					},
				})
			}

			if (hasTariffViewPermission) {
				sections.push({
					canEdit:
						this.userSession.getLoggedOperator().hasPermission(Activity.TARIFF_EDIT) &&
						!this.userSession.getLoggedOperator().hasPermission(Activity.LOCATION_DETAILS_READONLY_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.LocationTariff),

					name: this.$scope.LOCATION_TARIFF_ACCORDION_NAME,
					showInTab: this.$scope.LOCATION_COMMON_TAB_NAME,
					title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Tariff),

					showStatus: false,
					visible: true,

					editMethod: () => {
						this.$scope.$broadcast(EventsNames.OPEN_SELECT_POPOVER_POPUP + this.$scope.editId, this.$scope.locationTariffEditOptions)
					},
				})
			}

			if (hasAlarmDefViewPermission) {
				sections.push({
					canEdit:
						this.userSession.getLoggedOperator().hasPermission(Activity.LOCATION_EDIT) &&
						!this.userSession.getLoggedOperator().hasPermission(Activity.LOCATION_DETAILS_READONLY_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.LocationAlarmDef),

					name: this.$scope.LOCATION_ALARM_DEFS_ACCORDION_NAME,
					showInTab: this.$scope.LOCATION_COMMON_TAB_NAME,
					title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.AlarmDefs),

					showStatus: true,
					visible: true,

					editMethod: () => {
						this.onLocationAlarmDefEdit()
					},
					status: () => {
						return this.getLocationAlarmDefAccordionStatus()
					},
				})
			}

			const accordion: DetailsAccordion = new DetailsAccordion(this.$scope, this.$timeout, OperatorLayoutSettings.LocationAccordionsSettings, 2, sections)

			accordion.needRefresh = () => {
				this.refreshDetails()
			}

			accordions.push(accordion)
		}

		return accordions
	}

	public getTabs(addSchemaAccordion: boolean = false): any[] {
		const tabs: { template: string; name: string }[] = []

		const hasGeneralTabPermission: boolean =
			!this.userSession.getLoggedOperator().hasPermission(Activity.LOCATION_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.LocationParameters) ||
			!this.userSession.getLoggedOperator().hasPermission(Activity.LOCATION_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.LocationMeasurement) ||
			!this.userSession.getLoggedOperator().hasPermission(Activity.LOCATION_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.LocationGroups) ||
			!this.userSession.getLoggedOperator().hasPermission(Activity.LOCATION_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.LocationInstalledDevices) ||
			!this.userSession.getLoggedOperator().hasPermission(Activity.LOCATION_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.LocationInstalledMeters) ||
			!this.userSession.getLoggedOperator().hasPermission(Activity.LOCATION_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.LocationMap) ||
			!this.userSession.getLoggedOperator().hasPermission(Activity.LOCATION_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.LocationExtendedParameters) ||
			!this.userSession.getLoggedOperator().hasPermission(Activity.LOCATION_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.LocationConfigurationProfile) ||
			!this.userSession.getLoggedOperator().hasPermission(Activity.LOCATION_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.LocationAlarmDef) ||
			!this.userSession.getLoggedOperator().hasPermission(Activity.LOCATION_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.LocationTariff) ||
			(addSchemaAccordion && !this.userSession.getLoggedOperator().hasPermission(Activity.LOCATION_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.LocationGeneralSchema))

		if (hasGeneralTabPermission) {
			tabs.push({
				template: TemplateHelper.getIconWithText(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Common), ConfigHelper.Icon.HOME, this.userSession),
				name: this.$scope.LOCATION_COMMON_TAB_NAME,
			})
		}

		if (
			this.userSession.getLoggedOperator().hasPermission(Activity.MEASUREMENTS_LIST) &&
			!this.userSession.getLoggedOperator().hasPermission(Activity.LOCATION_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.LocationMeasurementPanel)
		) {
			tabs.push({
				template: TemplateHelper.getIconWithText(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Measurements), ConfigHelper.Icon.MEASUREMENTS, this.userSession),
				name: this.$scope.LOCATION_MEASUREMENTS_TAB_NAME,
			})
		}

		if (!this.userSession.getLoggedOperator().hasPermission(Activity.LOCATION_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.LocationHistory)) {
			tabs.push({
				template: TemplateHelper.getIconWithText(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.History), ConfigHelper.Icon.HISTORY, this.userSession),
				name: this.$scope.LOCATION_HISTORY_TAB_NAME,
			})
		}

		if (!this.userSession.getLoggedOperator().hasPermission(Activity.LOCATION_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.LocationSchema)) {
			tabs.push({
				template: TemplateHelper.getIconWithText(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Schema), ConfigHelper.Icon.SCHEMA, this.userSession),
				name: this.$scope.LOCATION_SCHEMA_TAB_NAME,
			})
		}

		return tabs
	}

	private setLocalizationText(): void {
		this.$scope.ConfigurationText = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Configuration)
		this.$scope.NoSchemaText = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoSchema)
	}

	private setDelegates(): void {
		this.$scope.getProfileFunctionNameText = (typeName: string): string => {
			return LocalizationHelper.getLocalizedText(typeName)
		}
		this.$scope.measurementsShow = () => {
			this.showGeneralMeasurements()
		}
		this.$scope.measurementsChartShow = () => {
			this.showGeneralMeasurementsChart()
		}
		this.$scope.isSchemasVisible = () => {
			return this.isSchemasVisible()
		}
		this.$scope.isMxGraphVisible = () => {
			return this.isMxGraphVisible()
		}
		this.$scope.profileSelectBoxExists = () => {
			return this.profileSelectBoxExists()
		}
		this.$scope.locationTariffSelectBoxExists = () => {
			return this.locationTariffSelectBoxExists()
		}

		this.$scope.canEditSection = (section: any) => {
			return this.canEditSection(section)
		}
	}

	private setBasicParameters(): JQueryPromise<void> {
		const def: JQueryDeferred<void> = $.Deferred<void>()
		this.$scope.detailsParametersOptions = null

		$
			.when<any>(
				this.locationService.getBasicParametersDataTypeGroup(this.referenceObject),
				this.userSession.getDataProvider().View.getActiveViews(),
				this.userSession.getDataProvider().System.getDictionaries([Enums.ReferenceType.IdDeviceType])
			)
			.then((dataTypeInGroup: OpDataTypeInGroup[], views: OpView[], dicts: Dictionary<Dictionary<IReferenceType>>) => {
				if (_.size(views) > 0) {
					this.locationView = _.find(views, (view: OpView) => view.idReferenceType == this.referenceType)
					this.deviceView = _.find(views, (view: OpView) => view.idReferenceType == Enums.ReferenceType.SerialNbr)
				}

				if (dicts != null) {
					const dict: Dictionary<IReferenceType> = dicts.tryGetValue(Enums.ReferenceType.IdDeviceType)

					if (dict != null) {
						this.deviceTypesDict = Dictionary.createFromArray<OpDeviceType>(
							dict
								.values()
								.map((refType: IReferenceType) => refType as OpDeviceType)
								.filter((deviceType: OpDeviceType) => deviceType != null),
							KeyType.Number,
							(devType: OpDeviceType) => devType.idDeviceType
						)
					}
				}

				this.$scope.detailsParametersOptions = {
					dataTypes: dataTypeInGroup,
					referenceType: this.referenceType,
					referenceObject: this.referenceObject,
					useDynamicValues: true,
					onDataLoaded: () => {
						def.resolve()
					}
				}
			})
			.catch(() => {
				def.reject()
			})

		if (this.isAccordionHidden(this.$scope.LOCATION_PARAMS_ACCORDION_NAME)) {
			def.resolve()
		}

		return def.promise()
	}

	private setExtendedParameters(): JQueryPromise<void> {
		const def: JQueryDeferred<void> = $.Deferred<void>()

		this.$scope.extendedParamsGridOptions = null

		// Timeout po to żeby GUI ogarnęło, że zmieniły się opcje
		setTimeout(() => {
			this.$scope.extendedParamsGridOptions = this.extendedParametersService.getExtendedParametersOptions({
				showLegend: true,
				treeName: LocationService.TREE_NAME_EXTENDED_PARAMETERS,
			})

			this.$scope.extendedParamsGridOptions.onInitialized = (args: any) => {
				this.onExtendedParametersInitialized(args)
			}
			this.$scope.extendedParamsGridOptions.onCellPrepared = (options: any) => {
				this.onExtendedParameterCellPrepared(options)
			}

			this.dataTypeGroupService
				.getDataTypeInGroupByCategory(
					[Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__GRID_PARAMS_TO_DISPLAY, Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__GRID_PARAMS_TO_EDIT],
					this.moduleName,
					{
						groupReferenceType: Enums.ReferenceType.IdDistributor,
						groupReferenceValue: this.referenceObject.idDistributor,
					}
				)
				.then((dataTypeInGroup: OpDataTypeInGroup[]) => {
					if (dataTypeInGroup == null) {
						dataTypeInGroup = []
					}

					const idDataTypes: number[] = dataTypeInGroup.map((dtig: OpDataTypeInGroup) => dtig.idDataType)

					if (idDataTypes.length > 0) {
						this.$scope.extendedParamsGridOptions.dataSource = this.extendedParametersService.createDataSourceForExtendedParameters({
							allowedDataTypes: idDataTypes,
							opObject: this.referenceObject,
							unitProvider: (data: IOpData) => (data as OpData).unit,
						})
					}

				})
				.always(() => {
					def.resolve()
				})
		})

		return def.promise()
	}

	private setAlarmDefinitionsOptions(): JQueryPromise<void> {
		const def: JQueryDeferred<void> = $.Deferred<void>()

		if (!this.userSession.getLoggedOperator().hasPermission(Activity.LOCATION_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.LocationAlarmDef)) {
			this.$scope.alarmDefinitionsOptions = {
				referenceType: this.referenceType,
				referenceObjectId: this.referenceObjectId,

				isColumnReorderAllowed: !this.userSession.getLoggedOperator().hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.LocationAlarmDef),

				onInitialized: (component: IAlarmDefinitions) => {
					this.onAlarmDefinitionsInitialized(component)
				},
			}

			this.$scope.alarmDefinitionsEditOptions = {
				alarmDefinitionsOptions: {
					referenceType: this.referenceType,
					referenceObject: this.referenceObject,
					moduleName: this.moduleName,

					onAlarmConfigurableSaved: (alarmConfigurable: IAlarmConfigurable) => {
						return this.onAlarmConfigurableSaved(alarmConfigurable)
					},

					sendConfiguration: null,
					configurationReferenceObject: null,
					sendConfigurationIdActivity: Activity.LOCATION_CONFIGURATION_SEND,
				},
				onInitialized: (component: AlarmDefinitionsEditController) => {
					this.alarmDefinitionsEditController = component
				},
			}
		}

		def.resolve()

		return def.promise()
	}

	private setSchemas(): JQueryPromise<void> {
		const def: JQueryDeferred<void> = $.Deferred<void>()

		this.$scope.isSchemasLoading = true
		this.$scope.schemas = []

		if (this.userSession.getLoggedOperator().hasPermission(Activity.SCHEMA_ADD)) {
			this.$scope.createSchemaButtonOptions = {
				text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.CreateSchema),
				onClick: () => {
					this.onCreateSchemaClick()
				},
			}
		}

		this.$scope.saveSchemaButtonOptions = {
			text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Save),
			onClick: () => {
				this.onSaveSchemaClick()
			},
		}

		$.when<any>(
			this.userSession.getDataProvider().Operator.getOperatorSettings(this.userSession.getDataProvider().Operator.getLastIdOperator(), [Enums.SimaxOperatorSetting.MxGraphDictionaryRule]),
			this.userSession.getDataProvider().DataType.getDataTypeDict()
		).then((scripts: any[], dataTypeDict: Dictionary<IReferenceType>) => {
			if (_.size(scripts) > 0) {
				scripts = [scripts[0]]
			}

			const currentLanguage: any = this.userSession.getDataProvider().System.getCurrentLanguage()

			const languageName: string = currentLanguage.split('-')[0]

			this.$scope.graphOptions = {
				location: this.referenceObject,
				schema: null,
				schemaModel: null,
				frameId: null,
				visualizationOnly: false,
				control: null,
				language: languageName,
				scripts: scripts,
				datatypeDict: dataTypeDict,
			}

			this.$scope.graphOptionsCommon = {
				location: this.referenceObject,
				schema: null,
				schemaModel: null,
				frameId: null,
				visualizationOnly: true,
				control: null,
				language: languageName,
				scripts: scripts,
				datatypeDict: dataTypeDict,
			}

			if (!this.userSession.getLoggedOperator().hasPermission(Activity.DEVICE_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.LocationGeneralSchema)) {
				this.userSession
					.getDataProvider()
					.System.getSchema(this.referenceType, [this.referenceObjectId])
					.then((result: OpSchema[]) => {
						if (result.length > 0) {
							const schemaCount: number = ConfigHelper.getValue(Enums.SimaxConfigSection.Schema, ConfigHelper.Key.MaxSchemaLimit)

							if (schemaCount != null) {
								result = result.slice(0, schemaCount)
							} else {
								LogHelper.log(LocationService.LOG_PREFIX, 'Unable to find schema number limit. Displaying all.')
							}

							const simpleXmlSchemas: SchemaModel[] = _.chain(result)
								.filter((schema: OpSchema) => schema.class === Enums.LocationSchemaClass.SimpleXml)
								.map((schema: OpSchema) => CommonHelper.opSchemaToSchemaModel(schema, this.userSession))
								.value()

							const mxGraphSchemas: OpSchema[] = _.filter(result, (schema: OpSchema) => schema.class === Enums.LocationSchemaClass.MXGraph)

							if (_.size(simpleXmlSchemas) > 0) {
								this.$scope.schemas = simpleXmlSchemas
							}

							if (_.size(mxGraphSchemas) > 0) {
								const unicodeStr: string = ConvertHelper.byteArrayToUnicodeString(<number[]>mxGraphSchemas[0].schema)

								this.$scope.graphOptionsCommon.schema = unicodeStr
								this.$scope.graphOptions.schema = unicodeStr

								const schema: SchemaModel = CommonHelper.opSchemaToSchemaModel(mxGraphSchemas[0], this.userSession)

								this.$scope.graphOptionsCommon.schemaModel = schema
								this.$scope.graphOptions.schemaModel = schema
							}
						}

						return result
					})
					.fail((error: any) => {
						const errorMsg: string = ConvertHelper.getRequestErrorMessage(error)

						ToastHelper.showError(errorMsg || LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ExceptionOccuredPleaseContactAnAdministrator))
						LogHelper.error(LocationService.LOG_PREFIX, 'Unable to load schema.')
					})
					.always(() => {
						this.$scope.isSchemasLoading = false
						def.resolve()
					})
			} else {
				this.$scope.isSchemasLoading = false
				def.resolve()
			}
		})

		return def.promise()
	}

	private setLocationSchemaAssignButtonOptions(): void {
		if (this.userSession.getLoggedOperator().hasPermission(Activity.SCHEMA_EDIT)) {
			this.$scope.locationSchemaAssignButtonOptions = {
				hint: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.AssignRemoveLocationSchema),
				template: TemplateHelper.getIcon(ConfigHelper.Icon.VIEW_CAROUSEL, this.userSession),
				onClick: () => {
					if(this.locationSchemaAssignPopup != null){
						this.locationSchemaAssignPopup.showPopup(this.referenceObjectId)
					}
				},
			}
		}
	}

	private setLocationSchemaAssignPopupOptions(): void {
		if (this.userSession.getLoggedOperator().hasPermission(Activity.SCHEMA_EDIT)) {
			this.$scope.locationSchemaAssignPopupOptions = {
				onInitialized: (e: IIMRLocationSchemaAssignPopupInitializedArgs) => {
					this.locationSchemaAssignPopup = e.component
				},
				onSubmited:()=>{
					this.setSchemas()
				}
			}
		}
	}

	private setMeasurementOptions(): JQueryPromise<void> {
		const def: JQueryDeferred<void> = $.Deferred<void>()

		$
			.when(this.userSession.getDataProvider().System.getDictionaries([Enums.ReferenceType.IdMeterType])).then((dictionaries: Dictionary<Dictionary<IReferenceType>>) => {
				const meterTypeDict: Dictionary<OpMeterType> = new Dictionary<OpMeterType>(null, KeyType.Number)

				if (dictionaries != null) {
					const meterTypeReferenceDict: Dictionary<IReferenceType> = dictionaries.tryGetValue(Enums.ReferenceType.IdMeterType)

					if (meterTypeReferenceDict != null) {
						meterTypeReferenceDict.forEach((key: string | number, value: IReferenceType) => {
							const meterType: OpMeterType = value as OpMeterType
							if (meterType != null) {
								meterTypeDict.addOrUpdate(key, meterType)
							}
						})
					}
				}

				// lokalizacja, id = id lokalizacji, name = tostring, referenceId = iddistrbutor
				const locations: MeasurementBridgeOpObjects[] = []

				// grupy lokalizacji, id = id lokalizacji, name = tostring, referenceId = iddistrbutor
				const groups: MeasurementBridgeOpObjects[] = []

				// liczniki, id = id meter, name = tostring, referenceId = meter type class
				const meters: MeasurementBridgeOpObjects[] = []

				// urządzenia, id = serialnbr, name = tostring, referenceId = device type
				const devices: MeasurementBridgeOpObjects[] = []

				locations.push({
					id: this.referenceObjectId,
					name: this.referenceObject.toString(),
					referenceId:
						this.referenceObject.idDistributor > 0
							? this.referenceObject.idDistributor
							: this.referenceObject.dataList != null && this.referenceObject.dataList.length > 0
								? this.referenceObject.dataList.getValue(Enums.DataType.HELPER_ID_DISTRIBUTOR)
								: null,
				})

				if (_.size(this.referenceObject.parentGroups) > 0) {
					this.referenceObject.parentGroups.forEach((location: OpLocation) => {
						const idDistributor: number =
							location.idDistributor > 0 ? location.idDistributor : location.dataList != null && location.dataList.length > 0 ? location.dataList.getValue(Enums.DataType.HELPER_ID_DISTRIBUTOR) : null

						groups.push({
							id: location.idLocation,
							name: location.toString(),
							referenceId: idDistributor,
						})
					})
				}

				if (_.size(this.referenceObject.currentDevices) > 0) {
					this.referenceObject.currentDevices.forEach((device: OpDevice) => {
						const idDeviceType: number =
							device.idDeviceType > 0 ? device.idDeviceType : device.dataList != null && device.dataList.length > 0 ? device.dataList.getValue(Enums.DataType.HELPER_ID_DEVICE_TYPE) : null

						devices.push({
							id: device.serialNbr,
							name: device.toString(),
							referenceId: idDeviceType,
						})
					})
				}

				if (_.size(this.referenceObject.currentMeters) > 0) {
					this.referenceObject.currentMeters.forEach((meter: OpMeter) => {
						const idMeterType: number =
							meter.idMeterType > 0 ? meter.idMeterType : meter.dataList != null && meter.dataList.length > 0 ? meter.dataList.getValue(Enums.DataType.HELPER_ID_METER_TYPE) : null

						const meterType: OpMeterType = idMeterType > 0 ? meterTypeDict.tryGetValue(idMeterType) : null

						meters.push({
							id: meter.idMeter,
							name: meter.toString(),
							referenceId: meterType == null ? null : meterType.idMeterTypeClass,
						})
					})
				}

				this.$scope.measurementsBridge = {
					id: this.referenceObjectId,
					referenceType: this.referenceType,
					requestProperty: 'locationIds',

					meters: meters,
					devices: devices,
					groups: locations, // THIS IS INTENDED
					//groups: groups,      // THESE 2 COMMENTED OUT LINES ARE INTENDED, DONT MAKE A MISTAKE AND USE groups: locations
					//locations: locations,// THESE 2 COMMENTED OUT LINES ARE INTENDED, DONT MAKE A MISTAKE AND USE groups: locations

					data: () => {
						return this.getMeasurementsData()
					},
					dataCallback: (data: MeasurementModel[]) => {
						this.setMeasurementsData(data)
					},
					chartBridgeCallback: (chartBridge: MeasurementsChartBridge) => {
						this.setMeasurementsChartBridge(chartBridge)
					},

					allowColumnReordering: this.userSession.getLoggedOperator().hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.LocationMeasurement),

					hideChartOptions: this.userSession.getLoggedOperator().hasPermission(Activity.WEBSIMAX_CHART_OPTION_HIDDEN, Enums.UIObjectProperties.LocationMeasurement),

					hideDataTypePanel: this.userSession.getLoggedOperator().hasPermission(Activity.WEBSIMAX_MEASUREMENT_DATA_TYPE_OPTION_HIDDEN, Enums.UIObjectProperties.LocationMeasurement),

					chartOptionsPermissions: null, // TODO: To delete in future
					chartDataTypeOptionsPermissions: null, // TODO: To delete in future
					latestDataMethodName: null, // TODO: To delete in future
					dataMethodName: null, // TODO: To delete in future
				}
			})
			.always(() => {
				def.resolve()
			})

		return def.promise()
	}

	private setConfirmationsOptions(): void {
		this.$scope.deleteConfirmationOptions = {
			title: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__DELETING, this.moduleName),
			onConfirmed: () => {
				this.onConfirmDelete()
			},
		}

		this.$scope.locationValidationConfirmationSource = {
			title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ConfirmChanges),
			onConfirmed: () => {
				this.validationDeferred.resolve(true)
			},
			onDeclined: () => {
				this.validationDeferred.resolve(false)
			},
		}

		this.$scope.sendLocationConfigurationProfileConfirmationSource = {
			title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ActionOfSendingProfile),
			onConfirmed: () => {
				this.sendLocationConfiguration()
			},
		}
	}

	private setEvents(): void {
		this.$scope.$on(EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__OPEN_DETAILS_POPUP, this.moduleName) + this.$scope.id, (event: ng.IAngularEvent, ...args: any[]) =>
			this.onOpen(args[3])
		)

		this.$scope.$on(EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__CLOSE_DETAILS_POPUP, this.moduleName) + this.$scope.id, () => this.onClose())

		this.$scope.$on(EventsNames.CLOSE_CREATE_EDIT_POPUP, (event: ng.IAngularEvent, ...args: any[]) => this.onRefresh(args[0]))

		this.$scope.$on(EventsNames.UPDATE_SCHEMAS, (event: ng.IAngularEvent, ...args: any[]) => this.setSchemas())

		this.$scope.$on(EventsNames.UPDATE_CONFIGURATION_PROFILE_FUNCTION_LIST, (event: ng.IAngularEvent, ...args: any[]) => this.onUpdateConfigurationProfileFunctionList(args))
	}

	private setOptions(): void {
		this.$scope.options = <DetailsPopupOptions>{
			id: this.$scope.id,
			actions: this.getActions(),

			openEventName: EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__OPEN_DETAILS_POPUP, this.moduleName),
			closeEventName: EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__CLOSE_DETAILS_POPUP, this.moduleName),

			delHasPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.LOCATION_DEL) ? Activity[Activity.LOCATION_DEL] : null,

			title: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__DETAILS, this.moduleName),

			deleteMethod: () => {
				this.onDelete()
			},
			getAccordionDataMethod: () => {
				return this.getAccordionData()
			},
			getAccordionSelectionMethod: () => {
				return this.getAccordionSelection()
			},
			updateAccordionMethod: (names: any[]) => {
				this.updateAccordions(names)
			},
			refreshButton: () => {
				if (this.$scope.tabs.selectedTabName === this.$scope.LOCATION_MEASUREMENTS_TAB_NAME) {
					this.$scope.measurementsBridge = null
				}

				this.onRefresh()
			},
		}
	}

	private setInstalledDevicesGridOptions(): JQueryPromise<void> {
		const def: JQueryDeferred<void> = $.Deferred<void>()

		this.$scope.installedDevicesGridOptions = null

		this.gridService
			.getColumnModelByCategory(Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__DEVICE_GRID_PARAMS, this.moduleName, {
				groupReferenceType: Enums.ReferenceType.IdDistributor,
				groupReferenceValue: this.referenceObject.idDistributor,
				viewReferenceType: Enums.ReferenceType.SerialNbr,
			})
			.then((columns: ColumnModel[]) => {
				this.$scope.installedDevicesGridOptions = {
					name: LocationsDetailsDirectiveController.LocationDevicesGridName,
					type: GridTypes.PAGINATED_SMALL,
					addCustomFilters: true,
					columnsDictionary: columns,
					getDataSource: () => {
						return $.Deferred<OpDevice[]>().resolve(this.referenceObject.currentDevices).promise()
					},

					buttonsOptions: {
						enabled: false,
					},

					allowColumnReordering: !this.userSession.getLoggedOperator().hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.LocationInstalledDevices),

					onRowDoubleClick: (args: any) => {
						this.onInstalledDevicesDoubleClick(args)
					},
					onInitialized: (args: any, controller: GridController<OpDevice>) => {
						this.onDeviceGridInitialized(args, controller)
					},
				}
			})
			.always(() => {
				def.resolve()
			})

		return def.promise()
	}

	private setInstalledMetersGridOptions(): JQueryPromise<void> {
		const def: JQueryDeferred<void> = $.Deferred<void>()

		this.$scope.installedMetersGridOptions = null

		this.gridService
			.getColumnModelByCategory(Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__METER_GRID_PARAMS, this.moduleName, {
				groupReferenceType: Enums.ReferenceType.IdDistributor,
				groupReferenceValue: this.referenceObject.idDistributor,
				viewReferenceType: Enums.ReferenceType.IdMeter,
			})
			.then((columns: ColumnModel[]) => {
				setTimeout(() => {
					this.$scope.installedMetersGridOptions = {
						name: LocationsDetailsDirectiveController.LocationMetersGridName,
						type: GridTypes.PAGINATED_SMALL,
						addCustomFilters: true,
						columnsDictionary: columns,
						getDataSource: () => {
							return $.Deferred<OpMeter[]>().resolve(this.referenceObject.currentMeters).promise()
						},

						buttonsOptions: {
							enabled: false,
						},

						allowColumnReordering: !this.userSession.getLoggedOperator().hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.LocationInstalledMeters),

						onRowDoubleClick: (args: any) => {
							this.onInstalledMetersDoubleClick(args)
						},
						onInitialized: (args: any, controller: GridController<OpMeter>) => {
							this.onMeterGridInitialized(args, controller)
						},
					}
				}, 500)
			})
			.always(() => {
				def.resolve()
			})

		return def.promise()
	}

	private setLocationGroupsGridOptions(): JQueryPromise<void> {
		const def: JQueryDeferred<void> = $.Deferred<void>()

		this.$scope.locationGroupsGridOptions = null

		this.$scope.locationGroupsGridOptions = {
			name: LocationsDetailsDirectiveController.LocationGroupsGridName,
			type: GridTypes.PAGINATED_SMALL,
			addCustomFilters: true,
			columnsDictionary: this.locationService.getLocationGroupsGridColumns(),
			dataSource: this.referenceObject.parentGroups,

			buttonsOptions: {
				enabled: false,
			},

			allowColumnReordering: !this.userSession.getLoggedOperator().hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.LocationGroups),

			onRowDoubleClick: (args: any) => {
				this.onLocationGroupsDoubleClick(args)
			},
			onInitialized: (args: any, grid: GridController<OpLocation>) => {
				this.onLocationGroupsGridInitialized(args, grid)
			},
		}

		def.resolve()

		return def.promise()
	}

	private setLocationIssuesGridOptions(): JQueryPromise<void> {
		const def: JQueryDeferred<void> = $.Deferred<void>()
		this.$scope.locationIssuesGridOptions = null
		this.$scope.showLocationIssues = false

		const deferred: JQueryDeferred<OpIssue[]> = $.Deferred<OpIssue[]>()

		if (this.referenceObject != null && this.referenceObject.idLocation > 0) {
			this.locationService.getLocationIssues(this.referenceObject.idLocation).then((issues: OpIssue[]) => {
				deferred.resolve(issues)
			})
		} else {
			deferred.resolve([])
		}

		deferred.promise()
			.then((issues: OpIssue[]) => {
				this.$scope.showLocationIssues = true
				this.locationIssues = issues

				this.$scope.locationIssuesGridOptions = {
					name: LocationsDetailsDirectiveController.LocationIssuesGridName,
					type: GridTypes.PAGINATED_SMALL,
					addCustomFilters: true,
					columnsDictionary: this.locationService.getLocationIssuesGridColumns(),
					dataSource: issues,

					buttonsOptions: {
						enabled: false,
					},

					allowColumnReordering: !this.userSession.getLoggedOperator().hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.LocationIssues),

					onRowDoubleClick: (args: any) => {
						this.onLocationIssuessDoubleClick(args, issues)
					},
					onInitialized: (e: any) => {
					}
				}
			})
			.always(() => {
				def.resolve()
			})

		return def.promise()
	}

	private setConfigurationProfileOptions(): JQueryPromise<void> {
		const def: JQueryDeferred<void> = $.Deferred<void>()

		this.$scope.profileFunctionsList = []
		this.$scope.isConfigurationProfileDescrtiptionVisible = false

		if (!this.userSession.getLoggedOperator().hasPermission(Activity.LOCATION_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.LocationConfigurationProfile)) {
			$.when<any>(
				this.referenceTypeService.getReferenceObjects(Enums.ReferenceType.IdConfigurationProfile),
				this.userSession.getDataProvider().Location.getLocationConfigurationProfile(this.referenceObjectId)
			)
				.then((configurationProfiles: DataProviderListResult<OpConfigurationProfile>, assignedConfigurationProfile: OpLocationConfigurationProfile) => {
					this.$scope.configurationProfiles = configurationProfiles.objects
					this.$scope.assignedConfigurationProfile = assignedConfigurationProfile

					if (this.$scope.assignedConfigurationProfile != null) {
						this.updateProfileParameters(this.$scope.assignedConfigurationProfile)
					}
				})
				.fail((error: any) => {
					LogHelper.error(LocationService.LOG_PREFIX, error)
				})
				.always(() => {
					def.resolve()
				})
		} else {
			def.resolve()
		}

		return def.promise()
	}

	private setSendLocationConfigurationProfileButtonOptions(): JQueryPromise<void> {
		const def: JQueryDeferred<void> = $.Deferred<void>()

		this.$scope.sendLocationConfigurationProfileButtonOptions = {
			hint: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.SendProfile),
			template: TemplateHelper.getIcon(ConfigHelper.Icon.DEVICES, this.userSession),
			onClick: () => {
				this.onSendLocationConfigurationProfileClick()
			},
		}

		def.resolve()
		return def.promise()
	}

	private setMapOptions(): JQueryPromise<void> {
		const def: JQueryDeferred<void> = $.Deferred<void>()

		$.when<any>(MapHelper.getDefaultOptions(this.userSession.getDataProvider()), MapHelper.getLegendItems(this.userSession.getDataProvider(), this.referenceType)).then(
			(mapOptions: MapOptions, items: MapLegendItem[]) => {
				mapOptions.hideCloseButton = true
				mapOptions.hideCounter = true
				mapOptions.hideTooltip = true

				mapOptions.legendItems = items

				mapOptions.onMapInit = (map: Map) => {
					this.onMapInit(map)
				}

				this.$scope.mapOptions = mapOptions
			}
		)
			.always(() => {
				def.resolve()
			})

		return def.promise()
	}

	private setLocationInstalledMetersBridgeOptions(): JQueryPromise<void> {
		const def: JQueryDeferred<void> = $.Deferred<void>()

		this.$scope.metersBridge = null

		$.when(
			this.gridService.getPopupColumnModelByReferenceType(Enums.ReferenceType.SerialNbr),
			this.gridService.getColumnModelByCategory(Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__METER_GRID_PARAMS, this.moduleName, {
				groupReferenceType: Enums.ReferenceType.IdDistributor,
				groupReferenceValue: this.referenceObject.idDistributor,
				viewReferenceType: Enums.ReferenceType.IdMeter,
			})
		).then((popupColumns: ColumnModel[], columns: ColumnModel[]) => {
			this.$scope.metersBridge = {
				columns,
				popupColumns,
				id: this.referenceObjectId,
				items: [],
				name: LocationsDetailsDirectiveController.LocationMetersBridgeName,
				popupId: this.LocationMetersBridgePopupIdName,
				title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.MetersEdit),
				isLoadingIndicatorDisabled: true,
				addPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.METER_ADD) ? "['" + Activity[Activity.METER_ADD] + "']" : null,

				allowColumnReordering: !this.userSession.getLoggedOperator().hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.LocationInstalledMeters),

				getAvailableDataSourceMethod: this.userSession.getDataProvider().Meter.getMeterFilter,

				onControllerInitialized: (controller: any) => {
					this.onMetersBridgeControllerInitialized(controller)
				},

				onAddClick: () => {
					this.meterService.openCreate(null, this.referenceObject).then((result: CreateEditResult<OpMeter>) => {
						if (result.status === CreateEditResult.Status.Success) {
							this.onRefresh()
						}
					})
				},

				onApply: (added: any, removed: any, inGrid: any) => {
					return this.onMetersBridgeApply(added, removed, inGrid)
				},
			}

			this.setMeterGridEditItems(this.referenceObject)
		}).always(() => {
			def.resolve()
		})

		return def.promise()
	}

	private setLocationInstalledDevicesBridgeOptions(): JQueryPromise<void> {
		const def: JQueryDeferred<void> = $.Deferred<void>()

		this.$scope.devicesBridge = null

		$.when(
			this.gridService.getPopupColumnModelByReferenceType(Enums.ReferenceType.IdMeter),
			this.gridService.getColumnModelByCategory(Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__DEVICE_GRID_PARAMS, this.moduleName, {
				groupReferenceType: Enums.ReferenceType.IdDistributor,
				groupReferenceValue: this.referenceObject.idDistributor,
				viewReferenceType: Enums.ReferenceType.SerialNbr,
			})
		).then((popupColumns: ColumnModel[], columns: ColumnModel[]) => {
			this.$scope.devicesBridge = {
				columns,
				popupColumns,
				id: this.referenceObjectId,
				items: [],
				name: LocationsDetailsDirectiveController.LocationDevicesBridgeName,
				popupId: this.LocationDevicesBridgePopupIdName,
				title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.DevicesEdit),
				isLoadingIndicatorDisabled: true,

				dataSourceParser: (device: OpDevice) => {
					if (device == null) {
						return null
					}

					const additionalFieldsObj: { additionalFields: { key: string; value: any }[] } = {
						additionalFields: [],
					}

					additionalFieldsObj.additionalFields.push({ key: CommonHelper.idReferenceField, value: device.idDeviceType })

					return additionalFieldsObj
				},

				allowColumnReordering: !this.userSession.getLoggedOperator().hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.LocationInstalledDevices),

				getAvailableDataSourceMethod: this.userSession.getDataProvider().Device.getDeviceFilter,

				onControllerInitialized: (controller: any) => {
					this.onDevicesBridgeControllerInitialized(controller)
				},
				onApply: (added: any, removed: any, inGrid: any) => {
					return this.onDevicesBridgeApply(added, removed, inGrid)
				},
			}

			this.setDeviceGridEditItems(this.referenceObject)
		}).always(() => {
			def.resolve()
		})

		return def.promise()
	}

	//#region Tariff

	private setLocationTariffOptions(): JQueryPromise<void> {
		const def: JQueryDeferred<void> = $.Deferred<void>()

		const textEntryType: string = 'Text'

		const tariffCodeValue: string =
			this.referenceObject.currentTariff != null && this.referenceObject.currentTariff.dataList != null ? this.referenceObject.currentTariff.dataList.getValue(Enums.DataType.TARIFF_CODE) : null
		const activationTimeValue: string =
			this.referenceObject.currentTariff != null &&
				this.referenceObject.currentTariff.dataList != null &&
				this.referenceObject.currentTariff.dataList.getValue(Enums.DataType.TARIFF_ACTIVATION_TIME) != null
				? ConvertHelper.dateToString(this.referenceObject.currentTariff.dataList.getValue(Enums.DataType.TARIFF_ACTIVATION_TIME))
				: null
		const activeTariffValue: string = this.referenceObject.currentTariff != null ? this.referenceObject.currentTariff.toString() : null

		const tariffCode: ConfigurationProfileEntry = {
			caption: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.TariffCode),
			name: 'tariffCode',
			value: tariffCodeValue != null ? tariffCodeValue : '\t',
			type: textEntryType,
			id: Enums.DataType.TARIFF_CODE,
			tooltip:
				tariffCodeValue != null
					? {
						icon: 'info_outline',
						tooltipText: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.TariffCode),
					}
					: null,
			styleForValue: tariffCodeValue != null ? { 'font-style': 'italic' } : {},
		}
		const activationTime: ConfigurationProfileEntry = {
			caption: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.TariffActivationTime),
			name: 'activationTime',
			value: activationTimeValue != null ? activationTimeValue : '\t',
			type: textEntryType,
			id: Enums.DataType.TARIFF_ACTIVATION_TIME,
			tooltip:
				activationTimeValue != null
					? {
						icon: 'info_outline',
						tooltipText: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.TariffActivationTime),
					}
					: null,
			styleForValue: tariffCodeValue != null ? { 'font-style': 'italic' } : {},
		}
		const activeTariff: ConfigurationProfileEntry = {
			caption: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ActiveTariff),
			name: 'activeTariff',
			value: activeTariffValue != null ? activeTariffValue : '\t',
			type: textEntryType,
			id: 'TARIFF_NAME',
			tooltip:
				this.referenceObject.currentTariff != null
					? {
						icon: 'info_outline',
						tooltipText: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ActiveTariff),
					}
					: null,
			styleForValue: activeTariffValue != null ? { 'font-style': 'italic' } : {},
		}

		this.$scope.locationTariffOptions = [tariffCode, activationTime, activeTariff]

		def.resolve()
		return def.promise()
	}

	private setLocationTariffEditOptions(): JQueryPromise<void> {
		const def: JQueryDeferred<void> = $.Deferred<void>()

		this.$scope.locationTariffEditOptions = {
			popupTitle: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.SelectTariff),
			selectPopoverSource: {
				referenceTypeId: Enums.ReferenceType.IdTariff,
				selectedId: this.referenceObject.currentTariff != null ? this.referenceObject.currentTariff.idTariff : null,
				dataTypeId: Enums.DataType.HELPER_ID_TARIFF,
			},
			allowEmptyValueSubmit: true,
			onSubmit: (idTariffToSave: number) => {
				this.saveTariff(idTariffToSave)
			},
		}

		def.resolve()

		return def.promise()
	}

	private saveTariff(idTariff: number): void {
		if (idTariff == null && this.referenceObject.currentTariff == null) {
			return
		}

		this.$scope.isLoading = true
		let tariffToSave: OpTariff
		if (idTariff != null) {
			tariffToSave = new OpTariff()
			tariffToSave.opState = Enums.OpChangeState.New
			tariffToSave.idTariff = idTariff
		} else {
			tariffToSave = this.referenceObject.currentTariff
			tariffToSave.opState = Enums.OpChangeState.Delete
		}
		this.referenceObject.currentTariff = tariffToSave
		this.locationService.saveLocation(this.referenceObject, this.moduleName).then((savedLocation: OpLocation) => {
			this.onRefresh(savedLocation)
			this.$scope.isLoading = false
			this.$scope.$root.$broadcast(EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__REFRESH, this.moduleName)) //need to refresh main grid source
		})
	}

	//#endregion

	// #region ItemSwapper options

	private setLocationGroupsItemSwapperOptions(): JQueryPromise<void> {
		const def: JQueryDeferred<void> = $.Deferred<void>()

		this.userSession
			.getDataProvider()
			.View.getActiveView(this.referenceType)
			.then((view: OpView) => {
				const locationNameColumn: OpViewColumn = _.find(view.columns, (column: OpViewColumn) => column.idDataType === Enums.DataType.LOCATION_NAME)

				const columnAvailableGroups: ColumnModel = new ColumnModel()
				columnAvailableGroups.idName = locationNameColumn.name.toLowerCase()
				columnAvailableGroups.name = 'availableGroups'
				columnAvailableGroups.caption = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.AvailableGroups)
				columnAvailableGroups.type = Enums.DataTypeClass.Text
				columnAvailableGroups.calculateCellValue = (data: any) => {
					return data == null ? TypeHelper.emptyString : this.gridService.getSourceObjectFromGridObject(data, LocationService.REFERENCE_TYPE).toString()
				}

				const columnAssignedGroups: ColumnModel = new ColumnModel()
				columnAssignedGroups.idName = locationNameColumn.name.toLowerCase()
				columnAssignedGroups.name = 'assignedGroups'
				columnAssignedGroups.caption = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.AssignedGroups)
				columnAssignedGroups.type = Enums.DataTypeClass.Text
				columnAssignedGroups.calculateCellValue = (data: any) => {
					return data == null ? TypeHelper.emptyString : this.gridService.getSourceObjectFromGridObject(data, LocationService.REFERENCE_TYPE).toString()
				}

				this.$scope.locationGroupsItemSwapperPopupOptions = {
					referenceType: this.referenceType,
					itemSwapperPopupTitle: () => {
						return this.getLocationGroupsItemSwapperTitle()
					},

					itemSwapperOptions: {
						rightGridOptions: {
							title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.AssignedGroups),
							columnsDictionary: [columnAssignedGroups],

							getDataSource: () => {
								return this.getParentGroups()
							},

							onRowDoubleClick: (args: any) => {
								this.onLocationGroupsLocationDoubleClick(args)
							},
						},

						leftGridOptions: {
							title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.AvailableLocations),
							columnsDictionary: [columnAvailableGroups],
							dataBag: true,

							getDataSourceFilter: (columns: ColumnInfo[], pageNbr: number, pageSize: number, customWhereClause: string) => {
								if (this.locationGroupsItemSwapperPopup != null && this.locationGroupsItemSwapperPopup.isVisible()) {
									return this.getAvailableParentLocations(columns, pageNbr, pageSize, customWhereClause)
								}

								return $.Deferred<any>().resolve(TypeHelper.NullObjectListResult).promise()
							},

							onRowDoubleClick: (args: any) => {
								this.onLocationGroupsLocationDoubleClick(args)
							},
						},
					},

					onSave: (result: ItemSwapperResult<OpLocation>) => {
						return this.onLocationGroupsSave(result)
					},
					onInitialized: (itemSwapper: IItemSwapperPopup<OpLocation>) => {
						this.onLocationGroupsItemSwapperInitialized(itemSwapper)
					},
				}
			})
			.always(() => {
				def.resolve()
			})

		return def.promise()
	}

	private getAvailableParentLocations(
		columns: ColumnInfo[],
		pageNbr: number,
		pageSize: number,
		customWhereClause: string
	): JQueryPromise<{ objects: any[]; totalCount: number; error: { code: any; msg: string } }> {
		if (this.userSession.getLoggedOperator().hasPermission(Activity.GROUPING_LOCATION_LIST)) {
			columns = this.locationView.columns.map((viewColumn: OpViewColumn) => {
				const columnInfo: ColumnInfo = new ColumnInfo(null)
				columnInfo.IdDataType = viewColumn.idDataType
				columnInfo.Name = viewColumn.name

				return columnInfo
			})

			return this.locationService.getAvailableParentLocations(this.locationView, columns, pageNbr, pageSize, customWhereClause)
		}

		return $.Deferred<{ objects: any[]; totalCount: number; error: { code: any; msg: string } }>().resolve({ objects: [], totalCount: 0, error: null }).promise()
	}

	// #endregion ItemSwapper options

	private setTemplateConsts(): void {
		this.$scope.LOCATION_COMMON_TAB_NAME = 'LOCATION_COMMON_TAB_NAME'
		this.$scope.LOCATION_MEASUREMENTS_TAB_NAME = 'LOCATION_MEASUREMENTS_TAB_NAME'
		this.$scope.LOCATION_HISTORY_TAB_NAME = 'LOCATION_HISTORY_TAB_NAME'

		this.$scope.LOCATION_PARAMS_ACCORDION_NAME = 'LOCATION_PARAMS_ACCORDION_NAME'
		this.$scope.LOCATION_EXTENDED_PARAMS_ACCORDION_NAME = 'LOCATION_EXTENDED_PARAMS_ACCORDION_NAME'

		this.$scope.DELETE_CONFIRMATION_POPUP_ID = this.$scope.detailsPopupId + '_DELETE_CONFIRMATION_POPUP'

		this.$scope.ACTION_RUN_POPUP_ID = this.$scope.detailsPopupId + '_ACTION_RUN_POPUP'
		this.$scope.ACTION_STATUS_POPUP_ID = this.$scope.detailsPopupId + '_ACTION_STATUS_POPUP'

		this.$scope.LOCATION_MEASUREMENT_CHART_ACCORDION_NAME = 'LOCATION_MEASUREMENT_CHART_ACCORDION_NAME'
		this.$scope.LOCATION_GROUPS_ACCORDION_NAME = 'LOCATION_GROUPS_ACCORDION_NAME'
		this.$scope.LOCATION_INSTALLED_DEVICES_ACCORDION_NAME = 'LOCATION_INSTALLED_DEVICES_ACCORDION_NAME'
		this.$scope.LOCATION_INSTALLED_METERS_ACCORDION_NAME = 'LOCATION_INSTALLED_METERS_ACCORDION_NAME'
		this.$scope.LOCATION_MEASUREMENT_TABLE_ACCORDION_NAME = 'LOCATION_MEASUREMENT_TABLE_ACCORDION_NAME'
		this.$scope.LOCATION_ISSUES_TABLE_ACCORDION_NAME = 'LOCATION_ISSUES_TABLE_ACCORDION_NAME'
		this.$scope.LOCATION_MAP_ACCORDION_NAME = 'LOCATION_MAP_ACCORDION_NAME'
		this.$scope.LOCATION_CONFIGURATION_PROFILE_ACCORDION_NAME = 'LOCATION_CONFIGURATION_PROFILE_ACCORDION_NAME'
		this.$scope.LOCATION_TARIFF_ACCORDION_NAME = 'LOCATION_TARIFF_ACCORDION_NAME'
		this.$scope.LOCATION_ALARM_DEFS_ACCORDION_NAME = 'LOCATION_ALARM_DEFS_ACCORDION_NAME'

		this.$scope.VALIDATION_WARNING_ID = new Date().getTime() + 'ValidationStatusWarning'
		this.$scope.SEND_LOCATION_CONFIGURATION_ID = new Date().getTime() + 'SendLocationConfigurationProfile'
	}

	private setHistoryOptions(): void {
		this.$scope.historySource = {
			dataMethodName: null, // TODO: To delete in future
			id: null, // TODO: To delete in future

			name: LocationsDetailsDirectiveController.LocationHistorySourceName,
			referenceType: this.referenceType,
			referenceValue: this.referenceObjectId,

			allowColumnReordering: !this.userSession.getLoggedOperator().hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.LocationHistory),

			onRowDoubleClick: null,
		}
	}

	// #endregion

	// #region Backward Compatibility - DO NOT USE, DELETE IN FUTURE

	public resetData(): void {
		this.onClear()
	}
	public loadData(id: number, objects: any[]): void {
		this.onOpen(null)
	}
	public updateData(result: any): void {
		this.onRefresh(result)
	}

	// #endregion

	// #region Profile

	private updateProfileParameters(profile: OpLocationConfigurationProfile): void {
		const textEntryType: string = 'Text'

		const configurationProfile: ConfigurationProfileEntry = {
			caption: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ConfigurationProfile),
			name: 'configurationProfile',
			value: profile.configurationProfile != null && profile.configurationProfile.name != '' ? profile.configurationProfile.name : '\t',
			type: textEntryType,
			id: profile.appliedConfigurationProfile != null ? profile.configurationProfile.idConfigurationProfile : 0,
			tooltip:
				profile.appliedConfigurationProfile == null || profile.appliedConfigurationProfile.idConfigurationProfile != profile.configurationProfile.idConfigurationProfile
					? {
						icon: 'info_outline',
						tooltipText: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ProfileNotApplied),
					}
					: null,
			styleForValue:
				profile.appliedConfigurationProfile == null || profile.appliedConfigurationProfile.idConfigurationProfile != profile.configurationProfile.idConfigurationProfile
					? { 'font-style': 'italic' }
					: {},
		}

		const appliedConfigurationProfile: ConfigurationProfileEntry = {
			caption: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.AppliedConfigurationProfile),
			name: 'appliedConfigurationProfile',
			value: profile.appliedConfigurationProfile == null || profile.appliedConfigurationProfile.name == '' ? '\t' : profile.appliedConfigurationProfile.name,
			type: 'Text',
			id: profile.appliedConfigurationProfile != null ? profile.appliedConfigurationProfile.idConfigurationProfile : '',
		}

		const appliedDate: ConfigurationProfileEntry = {
			caption: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.AppliedDate),
			name: 'appliedDate',
			value: profile.appliedDate != null ? moment(profile.appliedDate).format(ConfigHelper.getDateFormat(ConfigHelper.DateFormat.DATE_TIME_FORMAT_MOMENTJS)) : '\t',
			type: 'Datetime',
		}

		const appliedOperator: ConfigurationProfileEntry = {
			caption: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.AppliedOperator),
			name: 'appliedOperator',
			value: profile.appliedOperator != null && profile.appliedOperator.toString() != '' ? profile.appliedOperator.toString() : '\t',
			type: textEntryType,
			styleForValue:
				profile.appliedConfigurationProfile == null || profile.appliedConfigurationProfile.idConfigurationProfile != profile.configurationProfile.idConfigurationProfile
					? { 'font-style': 'italic' }
					: {},
		}

		this.$scope.locationProfileOptions = [configurationProfile, appliedConfigurationProfile, appliedDate, appliedOperator]

		const selectBoxModel: ConfigurationProfileSelectBoxItem[] = []
		this.$scope.configurationProfiles.forEach((value: OpConfigurationProfile) => {
			const descr: string = value.configuationProfileFuntionsDescr != null && value.configuationProfileFuntionsDescr.description != null ? value.configuationProfileFuntionsDescr.description : null

			selectBoxModel.push({
				id: value.idConfigurationProfile,
				name: value.name,
				descr: descr,
			})
		})

		this.$scope.profileSource = {
			popupTitle: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.SelectProfile),
			submitButtonText: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Submit),
			selectedValue: profile.configurationProfile != null ? profile.configurationProfile.idConfigurationProfile : null,
			itemsList: selectBoxModel,
			onSubmit: (idConfigurationProfile: number) => {
				this.onSelectConfigurationProfileClick(idConfigurationProfile, profile)
			},
		}

		this.$scope.isEditingConfigurationProfile = true
		this.$scope.isConfigurationProfileLoaderVisible = true

		if (profile.configurationProfile != null && profile.configurationProfile.configuationProfileFuntionsDescr != null) {
			this.$scope.isConfigurationProfileDescrtiptionVisible = true
			this.$scope.configurationProfileDescription = this.$sce.trustAsHtml(profile.configurationProfile.configuationProfileFuntionsDescr.description)
		} else {
			this.$scope.isConfigurationProfileDescrtiptionVisible = false
		}

		this.prepareScheduleFunctionsForView(profile)
	}

	private saveProfile(locationConfigurationProfile: OpLocationConfigurationProfile): void {
		this.$scope.isEditingConfigurationProfile = false
		this.$scope.isConfigurationProfileLoaderVisible = false

		locationConfigurationProfile.appliedOperator = this.userSession.getLoggedOperator()
		locationConfigurationProfile.appliedOperator.actor.avatar = null
		locationConfigurationProfile.appliedDate = new Date()
		locationConfigurationProfile.configurationProfile.opState = Enums.OpChangeState.Modified

		this.userSession
			.getDataProvider()
			.Location.saveLocationConfigurationProfile(locationConfigurationProfile)
			.then((result: OpLocationConfigurationProfile) => {
				ToastHelper.showSuccess(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.LocationProfileSaved))
				this.$scope.assignedConfigurationProfile = result
				this.setLocationStateTypeFlag()
				this.updateProfileParameters(result)
			})
			.fail((error: any) => {
				LogHelper.error(LocationService.LOG_PREFIX, error)
				ToastHelper.showError(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.LocationProfileSaveError))
				this.$scope.isEditingConfigurationProfile = true
				this.$scope.isConfigurationProfileLoaderVisible = true
			})
	}

	private prepareScheduleFunctionsForView(profile: OpLocationConfigurationProfile): void {
		this.$scope.profileFunctionsList = []
		this.$scope.deviceFunctionTypes = []

		this.$timeout(() => {
			if (profile.configurationProfile == null || profile.configurationProfile.functionList == null) {
				return
			}

			profile.configurationProfile.functionList = profile.configurationProfile.functionList.filter((functionItem: OpConfigurationProfileFunction) => {
				return functionItem.functionType == DeviceFunctionType.Schedule
			})

			profile.configurationProfile.functionList.forEach((functionItem: OpScheduleConfiguration, index: number) => {
				let i: number = 0
				let modelTemp: ScheduleConfigurationModel = new ScheduleConfigurationModel()

				modelTemp.dayOfMonth = functionItem.dayOfMonth
				modelTemp.dayOfWeek = functionItem.dayOfWeek != null && functionItem.dayOfWeek.length == 7 ? [255] : functionItem.dayOfWeek
				modelTemp.deviceFunctionType = functionItem.functionType

				switch (functionItem.functionType) {
					case DeviceFunctionType.Alarm: {
						modelTemp.deviceFunctionTypeString = DeviceFunctionType[DeviceFunctionType.Alarm]

						if (this.userSession.getLoggedOperator().hasPermission(Activity.ALARM_LIST)) {
							i++
						}

						break
					}
					case DeviceFunctionType.Archive: {
						modelTemp.deviceFunctionTypeString = DeviceFunctionType[DeviceFunctionType.Archive]
						break
					}
					case DeviceFunctionType.Schedule: {
						modelTemp.deviceFunctionTypeString = DeviceFunctionType[DeviceFunctionType.Schedule]

						if (this.userSession.getLoggedOperator().hasPermission(Activity.ALARM_LIST)) {
							i++
						}

						break
					}
					case DeviceFunctionType.Unknown: {
						modelTemp.deviceFunctionTypeString = DeviceFunctionType[DeviceFunctionType.Unknown]
						break
					}
					default: {
						modelTemp.deviceFunctionTypeString = TypeHelper.emptyString
						break
					}
				}

				modelTemp.functionString = functionItem.scheduleDisplayText
				modelTemp.hourOfDay = functionItem.hourOfDay == 255 ? null : functionItem.hourOfDay
				modelTemp.id = 0
				modelTemp.idConfigurationProfile = profile.configurationProfile.idConfigurationProfile
				modelTemp.indexNbr = functionItem.indexNbr
				modelTemp.isEnable = functionItem.isEnable
				modelTemp.isLocalTime = functionItem.isLocalTime
				modelTemp.minutesOfHour = functionItem.minutesOfHour

				if (i == 0 || index == 0) {
					this.$scope.deviceFunctionTypes.push({ name: modelTemp.deviceFunctionTypeString, id: modelTemp.deviceFunctionType })
				}

				this.$scope.profileFunctionsList.push(modelTemp)
			})
		})
	}

	// #endregion

	// #region Schema

	private createEmptySchema(): JQueryPromise<OpSchema> {
		const schemaToSave: OpSchema = new OpSchema(null)

		schemaToSave.schema = []
		schemaToSave.idObject = this.$scope.modelId
		schemaToSave.referenceType = Enums.ReferenceType.IdLocation
		schemaToSave.width = 0
		schemaToSave.height = 0
		schemaToSave.class = Enums.LocationSchemaClass.MXGraph
		schemaToSave.indexNbr = 1

		return this.saveOpxSchema(schemaToSave)
	}

	private saveOpxSchema(schemaToSave: OpSchema): JQueryPromise<OpSchema> {
		return this.userSession
			.getDataProvider()
			.System.saveSchema(Enums.ReferenceType.IdLocation, schemaToSave)
			.then((result: OpSchema) => {
				if (result == null) {
					console.info(LocationService.LOG_PREFIX, 'Unable to save schema.')
					ToastHelper.showError(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.FailedToSaveSchema))
				} else {
					ToastHelper.showSuccess(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.SchemaSaved))
				}

				return result
			})
			.fail((error: any) => {
				const errorMsg: string = ConvertHelper.getRequestErrorMessage(error)

				ToastHelper.showError(errorMsg || LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ExceptionOccuredPleaseContactAnAdministrator))
				LogHelper.warn(LocationService.LOG_PREFIX, 'Unable to create schema.')
			})
	}

	// #endregion

	// #region AlarmDefinitions

	private onAlarmDefinitionsInitialized(component: IAlarmDefinitions): void {
		this.alarmDefinitionsComponent = component
	}

	private onLocationAlarmDefEdit(): void {
		const hasEditPermission: boolean = this.userSession.getLoggedOperator().hasPermission(Activity.LOCATION_EDIT)
		const notReadonlyPermission: boolean = !this.userSession.getLoggedOperator().hasPermission(Activity.LOCATION_DETAILS_READONLY_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.LocationAlarmDef)

		if (hasEditPermission && notReadonlyPermission && this.alarmDefinitionsEditController != null) {
			this.alarmDefinitionsEditController.showSingleEdit()
		} else {
			LogHelper.log(
				LocationService.LOG_PREFIX,
				`onLocationAlarmDefEdit: hasEditPermission: ${hasEditPermission}, notReadonlyPermission: ${notReadonlyPermission}, alarmDefinitionEdit: ${this.alarmDefinitionsEditController == null ? '<null>' : 'Exists'
				}`
			)
		}
	}

	private getLocationAlarmDefAccordionStatus(): string {
		const alarmDefCount: number =
			this.referenceObject == null || this.referenceObject.currentAlarmDefs == null ? 0 : this.referenceObject.currentAlarmDefs.filter((alarmDef: OpAlarmDef) => alarmDef.idAlarmDef != 0).length

		return `${LocalizationHelper.getLocalizedText(LocalizationHelper.Text.DefinedCount)}${alarmDefCount}`
	}

	private onAlarmConfigurableSaved(alarmConfigurable: IAlarmConfigurable): void {
		if (alarmConfigurable == null) {
			return
		}

		this.referenceObject.currentAlarmDefs = alarmConfigurable.currentAlarmDefs

		if (this.alarmDefinitionsComponent != null) {
			this.alarmDefinitionsComponent.setDataSource(this.referenceObject.currentAlarmDefs)
		}

		this.$scope.$root.$broadcast(EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__REFRESH, this.moduleName)) //need to refresh main grid source
	}

	// #endregion

	// #region LocationsDetailsDirectiveController

	private canEditSection(section: any): boolean {
		return (
			(section.canEdit &&
				section.name != this.$scope.LOCATION_INSTALLED_DEVICES_ACCORDION_NAME &&
				section.name != this.$scope.LOCATION_INSTALLED_METERS_ACCORDION_NAME &&
				section.name != this.$scope.LOCATION_GROUPS_ACCORDION_NAME) ||
			(section.canEdit &&
				!this.$scope.isLocationStateTypeDeleted &&
				(section.name != this.$scope.LOCATION_INSTALLED_DEVICES_ACCORDION_NAME ||
					section.name != this.$scope.LOCATION_INSTALLED_METERS_ACCORDION_NAME ||
					section.name != this.$scope.LOCATION_GROUPS_ACCORDION_NAME))
		)
	}

	private setMapMarker(): JQueryPromise<void> {
		const def: JQueryDeferred<void> = $.Deferred<void>()

		if (this.referenceObject != null && this.map != null) {
			const marker: OpMarker = MapHelper.opLocationToOpMarker(this.referenceObject)
			if (marker != null) {
				this.map.setMarkers([marker], false, true)
			}
		}

		def.resolve()
		return def.promise()
	}

	private showGeneralMeasurements(): void {
		this.$scope.isGeneralMeasurementsMockRequired = false
		this.isMeasurmentVisible = true
	}

	private showGeneralMeasurementsChart(): void {
		this.$scope.isGeneralMeasurementsMockRequired = !this.isMeasurmentVisible
	}

	private getMeasurementsData(): MeasurementModel[] {
		return this.measurementsData
	}

	private setMeasurementsChartBridge(chartBridge: MeasurementsChartBridge): void {
		this.$scope.measurementsChartBridge = chartBridge
	}

	private setMeasurementsData(data: MeasurementModel[]): void {
		this.measurementsData = data
	}

	private locationGroupsStatus(): string {
		const count: number = this.referenceObject != null && this.referenceObject.parentGroups != null ? this.referenceObject.parentGroups.length : 0

		return `${LocalizationHelper.getLocalizedText(LocalizationHelper.Text.AssignedCount)}${count}`
	}

	private locationInstalledDevicesStatus(): string {
		const count: number = this.referenceObject != null && this.referenceObject.currentDevices != null ? this.referenceObject.currentDevices.length : 0

		return `${LocalizationHelper.getLocalizedText(LocalizationHelper.Text.InstalledCount)}${count}`
	}

	private locationInstalledMetersStatus(): string {
		const count: number = this.referenceObject != null && this.referenceObject.currentMeters != null ? this.referenceObject.currentMeters.length : 0

		return `${LocalizationHelper.getLocalizedText(LocalizationHelper.Text.InstalledCount)}${count}`
	}

	private sendLocationConfiguration(): void {
		if (this.$scope.assignedConfigurationProfile.configurationProfile != null) {
			const idProfile: number = this.$scope.assignedConfigurationProfile.configurationProfile.idConfigurationProfile
			this.userSession
				.getDataProvider()
				.Location.sendLocationConfiguration([this.referenceObjectId], idProfile)
				.then((result: OpActionResult[]) => {
					const actionStatusOptions: ActionStatusOptions = {
						actionResult: result,
						selectedRowsNames: [this.$scope.popupTitle],
						moduleDataType: Enums.DataType.HELPER_ID_LOCATION,
						onActionPopupClosed: (e: any) => {
							if (_.size(e) > 0 && e[0] != null && e[0].succeded) {
								this.$scope.assignedConfigurationProfile.appliedConfigurationProfile = this.$scope.assignedConfigurationProfile.configurationProfile
								this.updateProfileParameters(this.$scope.assignedConfigurationProfile)
							}
						},
					}
					this.$scope.$broadcast(EventsNames.SHOW_ACTION_STATUS_POPUP + this.$scope.ACTION_STATUS_POPUP_ID, actionStatusOptions)
				})
				.fail((error: any) => {
					ToastHelper.showError(ConvertHelper.getRequestErrorMessage(error))
				})
		} else {
			ToastHelper.showError(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoConfigurationProfileSelected))
		}
	}

	private setLocationStateTypeFlag(): JQueryPromise<void> {
		const def: JQueryDeferred<void> = $.Deferred<void>()
		this.$scope.isLocationStateTypeDeleted = this.referenceObject.idLocationStateType == Enums.LocationStateType.DELETED
		def.resolve()
		return def.promise()
	}

	private refreshDetails(): void {
		this.mapUpdate()

		if (this.$scope.measurementsChartBridge != null) {
			this.$scope.measurementsChartBridge.updateChart = true
		}
	}

	private getLocationGroupsItemSwapperTitle(): string {
		const count: number = this.locationGroupsItemSwapperPopup == null ? 0 : this.locationGroupsItemSwapperPopup.itemSwapper.getRightGridItemsCount()

		return `${LocalizationHelper.getLocalizedText(LocalizationHelper.Text.GroupEdit)} (${count})`
	}

	private isMxGraphVisible(): boolean {
		return this.$scope.graphOptionsCommon != null && this.$scope.graphOptionsCommon.schema != null
	}

	private isSchemasVisible(): boolean {
		return this.$scope.schemas != null && this.$scope.schemas.length > 0 && this.$scope.graphOptionsCommon != null && this.$scope.graphOptionsCommon.schema == null
	}

	private profileSelectBoxExists(): boolean {
		return this.$scope.isEditingConfigurationProfile != null && this.userSession.getLoggedOperator().hasPermission(Activity.LOCATION_EDIT)
	}

	private locationTariffSelectBoxExists(): boolean {
		return (
			!this.userSession.getLoggedOperator().hasPermission(Activity.LOCATION_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.LocationTariff) &&
			this.userSession.getLoggedOperator().hasPermission(Activity.TARIFF_EDIT) &&
			!this.userSession.getLoggedOperator().hasPermission(Activity.LOCATION_DETAILS_READONLY_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.LocationTariff)
		)
	}

	private getParentGroups(): JQueryPromise<OpLocation[]> {
		return $.Deferred<OpLocation[]>().resolve(this.referenceObject.parentGroups).promise()
	}

	private setDeviceGridEditItems(location: OpLocation): void {
		this.referenceObject.currentDevices = location.currentDevices

		const items: any[] =
			location != null && location.currentDevices != null
				? location.currentDevices
					.filter((device: OpDevice) => device != null)
					.map((device: OpDevice) => {
						if (device.dynamicValues == null) {
							device.dynamicValues = []
						}

						const gridObj: any = this.gridService.gridObjectFromIOpObject(device)

						gridObj[CommonHelper.idReferenceField] = device.idDeviceType

						return gridObj
					})
				: []

		this.$scope.devicesBridge.items = items
	}

	private setMeterGridEditItems(location: OpLocation): void {
		this.referenceObject.currentMeters = location.currentMeters

		const items: any[] =
			location != null && location.currentMeters != null
				? location.currentMeters
					.filter((meter: OpMeter) => meter != null)
					.map((meter: OpMeter) => {
						if (meter.dynamicValues == null) {
							meter.dynamicValues = []
						}

						return this.gridService.gridObjectFromIOpObject(meter)
					})
				: []

		this.$scope.metersBridge.items = items
	}

	/**
	 * Tries to save location.
	 * First performs validation, then depending on validation results saves location, or asks if should save, or rejects save.
	 * */
	private trySaveLocation(toSave: OpLocation): JQueryPromise<OpLocation> {
		const deferred: JQueryDeferred<OpLocation> = $.Deferred<OpLocation>()

		this.locationService
			.validateLocation(toSave)
			.then((validationResult: OpValidateInfo[]) => {
				if (_.size(validationResult) > 0) {
					const validateInfo: OpValidateInfo = validationResult[0]

					switch (validateInfo.Status) {
						case Enums.ValidationStatus.Correct: {
							return this.saveLocation(toSave)
								.then((location: OpLocation) => {
									deferred.resolve(location)
								})
								.fail(() => {
									deferred.reject(null)
								})
						}
						case Enums.ValidationStatus.Warning: {
							const errorMsg: string = validateInfo.Message.join(TypeHelper.HTMLNewLine)

							this.validationDeferred = $.Deferred<boolean>()

							this.validationDeferred
								.promise()
								.then((result: boolean) => {
									if (result) {
										this.saveLocation(toSave)
											.then((location: OpLocation) => {
												deferred.resolve(location)
											})
											.fail(() => {
												deferred.reject(null)
											})
									} else {
										deferred.reject(null)
									}
								})
								.fail(() => {
									deferred.reject(null)
								})

							this.$timeout(() => {
								this.$scope.$broadcast(EventsNames.OPEN_CONFIRMATION_POPUP + this.$scope.VALIDATION_WARNING_ID, errorMsg)
							})

							break
						}
						case Enums.ValidationStatus.Incorrect: {
							const errorMsg: string = validateInfo.Message.join(TypeHelper.HTMLNewLine)

							ToastHelper.showError(errorMsg)
							deferred.reject(null)
							break
						}
						default: {
							ToastHelper.showError(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ExceptionOccuredPleaseContactAnAdministrator))
							deferred.reject(null)
							break
						}
					}
				} else {
					ToastHelper.showError(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ExceptionOccuredPleaseContactAnAdministrator))
					deferred.reject(null)
				}
			})
			.fail(() => {
				deferred.reject(null)
			})

		return deferred.promise()
	}

	private saveLocation(toSave: OpLocation): JQueryPromise<OpLocation> {
		return this.locationService.saveLocation(toSave, this.moduleName, false).then((saved: OpLocation) => {
			this.referenceObject.currentDevices = saved.currentDevices
			this.referenceObject.currentMeters = saved.currentMeters

			if (this.deviceGridController != null && this.deviceGridController.dxGrid != null) {
				this.deviceGridController.dxGrid.refresh()
			}

			if (this.meterGridController != null && this.meterGridController.dxGrid != null) {
				this.meterGridController.dxGrid.refresh()
			}

			return saved
		})
	}

	private saveInstalledDevices(addedRows: any[], removedRows: any[], inGrid: any[]): JQueryPromise<boolean> {
		return this.locationEquipmentService.saveInstalledDevices({
			editId: this.$scope.editId,
			scope: this.$scope,

			addedRows: addedRows,
			removedRows: removedRows,
			inGrid: inGrid,

			locationView: this.locationView,
			deviceView: this.deviceView,
			location: this.referenceObject,

			deviceTypesDict: this.deviceTypesDict,

			saveLocationDelegate: (location: OpLocation) => this.trySaveLocation(location),

			locationSavedDelegate: (location: OpLocation) => {
				if (location != null) {
					this.setDeviceGridEditItems(location)
					this.setMeterGridEditItems(location)
					ToastHelper.showSuccess(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.EquipmentAssigned))
					this.$scope.$root.$broadcast(EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__REFRESH, this.moduleName)) //need to refresh main grid source
					return true
				}

				return false
			},

			saveFailedDelegate: () => {
				ToastHelper.showWarning(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Canceled))
				return false
			},

			saveAlwaysDelegate: () => {
				this.devicesGridEditController.setIsLoading(false)
			},

			setConfirmationSourceDelegates: (onConfirmed: () => void, onCanceled: () => void) => {
				this.$scope.meterDeviceRelocationConfirmationSource = {
					title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.MeterRelocation),
					onConfirmed: () => onConfirmed(),
					onDeclined: () => onCanceled(),
				}
			},
		})
	}

	private saveInstalledMeters(addedRows: any[], removedRows: any[], inGrid: any[]): JQueryPromise<boolean> {
		return this.locationEquipmentService.saveInstalledMeters({
			editId: this.$scope.editId,
			scope: this.$scope,

			addedRows: addedRows,
			removedRows: removedRows,
			inGrid: inGrid,

			locationView: this.locationView,
			deviceView: this.deviceView,
			location: this.referenceObject,

			deviceTypesDict: this.deviceTypesDict,

			saveLocationDelegate: (location: OpLocation) => this.trySaveLocation(location),

			locationSavedDelegate: (location: OpLocation) => {
				if (location != null) {
					this.setDeviceGridEditItems(location)
					this.setMeterGridEditItems(location)
					ToastHelper.showSuccess(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.EquipmentAssigned))
					this.$scope.$root.$broadcast(EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__REFRESH, this.moduleName)) //need to refresh main grid source
					return true
				}

				return false
			},

			saveFailedDelegate: () => {
				ToastHelper.showWarning(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Canceled))
				return false
			},

			saveAlwaysDelegate: () => {
				this.metersGridEditController.setIsLoading(false)
			},

			setConfirmationSourceDelegates: (onConfirmed: () => void, onCanceled: () => void) => {
				this.$scope.meterDeviceRelocationConfirmationSource = {
					title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.DeviceRelocation),
					onConfirmed: () => onConfirmed(),
					onDeclined: () => onCanceled(),
				}
			},
		})
	}

	// #endregion
}
